import { Component, ViewChild, TemplateRef, ElementRef, Input, OnInit, OnDestroy, AfterViewInit, OnChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatePipe } from '@angular/common';
import { AppService } from '../app.service';
import { qmsService } from '../qms/qms.service';
import { forkJoin, firstValueFrom } from 'rxjs';
import { PaginationService } from '../PaginationService';
import { messageService } from '../message.service';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { SuccessSnackbarComponent } from '../support/success-snackbar/success-snackbar.component';
import { EditorComponent } from '../editor/editor.component';
import { BsDatepickerConfig, DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
@Component({
  selector: 'app-activity-report',
  templateUrl: './activity-report.component.html',
  styleUrls: ['./activity-report.component.scss']
})
export class ActivityReportComponent implements OnChanges, OnInit, AfterViewInit, OnDestroy {
  isProcessing: boolean = false;
  isNavigatingToDetails: boolean = false;
  selectedReportFooter: any;
  reportFooterDropdown1: any = [];
  reportFooterDropdown: any = [];
  reportFooterFieldValidation: any;

  refreshbreadcrumb: boolean = true;
  auditGridFlag = "default";
  showCharts: boolean = false;
  showReportFlagValue: any;
  PageName: any;
  searchValue: any;
  error = '';
  makeStickyColumns: any;
  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  statusCodeValue: any;
  columnLists: any = {};
  dataTypeList: any = [];
  array: any = [];
  totalClickFlag: boolean = false;
  dropDownForModules: any;
  popupTitle: any;
  groupValueDropdown: any = [];
  groupdataList: any = [];
  stageAndStatus: any = [];
  dropDownForDateRange: any = [];
  dropDownForAuDateRange: any = [];
  dropDownForInterval: any = [];
  stageValueDropdown: any = [];
  dateRangeValueDropdown: any = [];
  dateRangeValueAuDropDown: any = [];
  statusValueDropdown: any = [];
  statusValueDropdown1: any = [];
  intervalValueDropdown: any = [];
  selectedStatusValue: any = null;
  selectedDateRangeValue: any = null;
  selectedAuDateRangeValue: any = null;
  selectedIntervalValue: any = null;
  selectedStageValue: any = null;
  selectedGroupValue: any = null;
  showSpecificInterval: boolean = false;
  titleName = '';
  clickedType = "";
  clickedVal = "";
  clickedStageStatusVal = "";
  dateCustomClasses: DatepickerDateCustomClasses[];
  chartOptionsForStages: any;
  chartOptionsForOOSType: any;
  chartOptionsForStatus: any;
  chartOptionsForBa: any;
  chartOptionsForDepartment: any;
  chartOptionsForTaskType: any;
  chartOptionsForDueInDays: any;
  chartOptionsForActivity: any;
  chartOptionsForActivityInprogressVSTotal: any;
  chartOptionsForEC: any;
  chartOptionsForExtention: any;
  chartOptionsForAction: any;
  chartOptionsForStagesStatus: any;
  chartOptionsForSeverity: any;
  chartOptionsForStagesZoom: any;
  chartOptionsForDueInDaysZoom: any;
  chartOptionsForStatusZoom: any;
  chartOptionsForBaZoom: any;
  chartOptionsForDepartmentZoom: any;
  chartOptionsForTaskTypeZoom: any;
  chartOptionsForActivityZoom: any;
  chartOptionsForActivityInprogressVSTotalZoom: any;
  chartOptionsForECZoom: any;
  chartOptionsForExtentionZoom: any;
  chartOptionsForActionZoom: any;
  chartOptionsForStagesStatusZoom: any;
  chartOptionsForFinding: any;
  searchByDepartmentCode: any = null;
  departmentCodeValue: any;
  departmentCodeDropdown: any = [];
  dropDownForDepartmentCode: any = [];
  selectedDepartmentValue: any = [];
  chartOptionsForFollowup: any;
  chartOptionsForRecommandation: any;
  chartOptionsForFindingZoom: any;
  chartOptionsForFollowupZoom: any;
  chartOptionsForRecommandationZoom: any;
  chartOptionsForSeverityZoom: any;
  annualRefNo: any;
  isDropdownDisabled: boolean = true;
  departmentSearchText: string = '';
  selectedGroupNameForBredcrumb: any;
  stageList: any = [];
  stageExcelList: any = [];
  oosTypeList: any = [];
  oosTypeExcelList: any = [];
  statusList: any = [];
  statusExcelList: any = [];
  baList: any = [];
  baExcelList: any = [];
  departmentList: any = [];
  departmentExcelList: any = [];
  taskTypeList: any = [];
  taskTypeExcelList: any = [];
  dueInDaysList: any = [];
  dueInDaysExcelList: any = [];
  activityReportList: any = [];
  inprogressVSTotalList: any = [];
  stageStatusList: any = [];
  stageStatusExcelList: any = [];
  tableReportDataList: any = [];
  tempTableReportDataList: any = [];
  extensionTableReportDataList: any = [];
  ecTableReportDataList: any = [];
  actionTableReportDataList: any = [];
  findingTableReportDataList: any = [];
  followupTableReportDataList: any = [];
  recommendationTableReportDataList: any = [];
  dueInDaysTableReportDataList: any = [];
  ecList: any = [];
  ecExcelList: any = [];
  extensionList: any = [];
  extensionExcelList: any = [];
  actionList: any = [];
  actionExcelList: any = [];
  findingList: any = [];
  findingExcelList: any = [];
  followupList: any = [];
  followupExcelList: any = [];
  RecommendationList: any = [];
  RecommendationExcelList: any = [];
  severityList: any = [];
  severityExcelList: any = [];
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  users: any[];
  pager: any = {};
  pagedItems: any[];
  pagedItems1: any[];
  pagedItems2: any[];
  pagedItems3: any[];
  pagedItems5: any[];
  pagedItems6: any[];
  pagedItems7: any[];
  pagedItems8: any[];
  showMore: boolean = false;
  selectedQmsDept: any = [];
  qmsDeptSelection = false;

  showBAChart: boolean = false;

  toggleMore() {
    this.showMore = !this.showMore;
  }

  @ViewChild('qmsDeptVal') qmsDeptVal: MatSelect;
  @ViewChild(BreadcrumbComponent) breadcrumbComponent!: BreadcrumbComponent;
  constructor(public dialog: MatDialog, public route: ActivatedRoute, public appService: AppService, public router: Router, public snackBar: MatSnackBar,
    public elem: ElementRef, public qmsservice: qmsService, public message: messageService, public datePipe: DatePipe, public activatedRoute: ActivatedRoute,
    public paginationService: PaginationService) {
    appService.isProcessingRep = false;
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
    this.toDate = new Date();
    // Set the date 365 days before the current date
    this.fromDate = new Date();
    this.fromDate.setDate(this.toDate.getDate() - 365);
    // Set the minDate and maxDate for the date picker
    this.minDate = new Date(this.fromDate.getFullYear() - 1000, 0, 1);;
    this.maxDate = this.toDate;
  }
  ngAfterViewInit(): void {
    throw new Error('Method not implemented.');
  }

  ngOnDestroy() {
    if (this.isNavigatingToDetails) {
      return;
    }
    this.message.breadcrumbData.thirdLevel = '';
    this.message.breadcrumbData.fourthLevel = '';
  }

  datePickerConfiguration: Partial<BsDatepickerConfig>;

  fromDate: Date;
  toDate: Date;
  maxDate: Date;
  minDate: Date;
  @ViewChild('reportPopup', { static: true }) reportPopup: TemplateRef<any>;
  visibleReportPopup: MatDialogRef<TemplateRef<any>>;

  @ViewChild('reportPopupForZoom', { static: true }) reportPopupForZoom: TemplateRef<any>;
  visibleReportPopupForZoom: MatDialogRef<TemplateRef<any>>;

  reportPopupConfig = {
    width: '120%',
    height: '680px',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px', left: '125px' },
    maxWidth: '90vw',
  };

  colorList: string[] = [
    '#F9F871',
    '#6B7887',
    '#00A6A9',
    '#BF83FF',
    '#005C8A',
    '#05004E',
    '#834160',
    '#9EADBD',
    '#BA7393',
    '#DEEBFE',
    '#96E480',
    '#839EFF',
    '#00A6A9',
    '#0081A5',
    '#291F1E',
    '#401F3E',
    '#C0DFA1',
    '#14342B',
    '#D0DB97',
    '#B07BAC',
    '#CF1259',
    '#E6B89C'
  ];

  colorMethod(val: any, iVal: any) {
    if (val == "Closed" || val == "Completed" || val == "Passed") {
      return "#96E480";
    } else if (val == "Critical" || val == "High") {
      return "#EB5757";
    } else if (val == "Major" || val == "Medium") {
      return "#FF947A";
    } else if (val == "In Progress" || val == "Minor") {
      return "#005C8A";
    } else {
      return this.colorList[iVal];;
    }
  }


  onStageValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.selectedStatusValue = null;
        for (let i = 0; i < this.stageAndStatus.length; i++) {
          if (this.stageAndStatus[i].stageName == item.valueExp) {
            this.statusValueDropdown = [];
            const statusArray = this.stageAndStatus[i].listOfStatus.split(',').map((status: string) => status.trim());
            this.statusValueDropdown = this.statusValueDropdown.concat(statusArray.filter((status: any) => !this.statusValueDropdown.includes(status)));
          }
          if (i == this.stageAndStatus.length - 1) {
            this.statusValueDropdown.sort((a: any, b: any) => a.localeCompare(b));
            this.statusValueDropdown1 = [];
            for (const statusValue of this.statusValueDropdown) {
              this.statusValueDropdown1 = this.statusValueDropdown1.concat({
                valueExp: statusValue,
                displayExp: statusValue
              });
            }
          }
        }
        if (item.valueExp == 'Plan') {
          this.auditGridFlag = "plan";
        } else if (item.valueExp == 'Schedule') {
          this.auditGridFlag = "schedule";
        } else {
          this.auditGridFlag = "conduct";
        }
      } else {
        this.selectedStatusValue = null;

        this.auditGridFlag = 'default';
      }
    }
  }

  onStatusValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        if (item == 'Planned' || item == 'Plan Rejected' || item == 'Plan Created' || item == 'Plan Deleted' || item == 'Draft(Plan)' || item == 'Re-Draft(Plan)' || item == 'Pending Plan Approval' || item == 'Plan Cancelled') {
          this.auditGridFlag = "plan";
        } else if (item == 'Scheduled' || item == 'Schedule Rejected' || item == 'Schedule Created' || item == 'Schedule Deleted' || item == 'Draft(Schedule)' || item == 'Re-Draft(Schedule)' || item == 'Pending Schedule Approval' || item == 'Schedule Cancelled') {
          this.auditGridFlag = "schedule";
        } else {
          this.auditGridFlag = "conduct";
        }
      }
    }
  }

  selectBoxeForGroupValue() {
    this.groupValueDropdown = [];
    for (const groupData of this.groupdataList) {
      this.groupValueDropdown = this.groupValueDropdown.concat({
        valueExp: groupData.groupId,
        displayExp: groupData.groupName
      });
    }
  }
  selectBoxForDateRange() {
    this.dateRangeValueDropdown = [];
    for (const dateRange of this.dropDownForDateRange) {
      this.dateRangeValueDropdown = this.dateRangeValueDropdown.concat({
        valueExp: dateRange.codelistCode,
        displayExp: dateRange.codelistName
      });
    }
  }
  selectBoxForAuDateRange() {
    this.dateRangeValueAuDropDown = [];
    for (const dateRange of this.dropDownForAuDateRange) {
      this.dateRangeValueAuDropDown = this.dateRangeValueAuDropDown.concat({
        valueExp: dateRange.codelistCode,
        displayExp: dateRange.codelistName
      });
    }
  }
  selectBoxForInterval() {
    this.intervalValueDropdown = [];
    for (const interval of this.dropDownForInterval) {
      this.intervalValueDropdown = this.intervalValueDropdown.concat({
        valueExp: interval.codelistCode,
        displayExp: interval.codelistName
      });
    }
  }

  selectBoxeForStageValue() {
    this.stageValueDropdown = [];
    for (const stage of this.stageAndStatus) {
      this.stageValueDropdown = this.stageValueDropdown.concat({
        valueExp: stage.stageName,
        displayExp: stage.stageName
      });
    }
    this.stageAndStatus.forEach((item: { listOfStatus: string; }) => {
      const statusArray = item.listOfStatus.split(',').map(status => status.trim());
      this.statusValueDropdown = this.statusValueDropdown.concat(statusArray.filter(status => !this.statusValueDropdown.includes(status)));
    });
    this.statusValueDropdown1 = [];
    for (const statusValue of this.statusValueDropdown) {
      this.statusValueDropdown1 = this.statusValueDropdown1.concat({
        valueExp: statusValue,
        displayExp: statusValue
      });
    }

  }

  specificIntervalVal: boolean = true;
  specificIntervalFun(e: any) {
    if (e.checked) {
      this.specificIntervalVal = true;
      this.showSpecificInterval = true;
      this.selectedIntervalValue = 'MONTH';
      this.selectedDateRangeValue = 'CREATED';
      this.selectedAuDateRangeValue = 'STARTED';
    } else {
      this.specificIntervalVal = false;
      this.showSpecificInterval = false;
      this.selectedIntervalValue = '';
      this.selectedDateRangeValue = '';
      this.selectedAuDateRangeValue = '';
    }
  }


  resetFunction() {
    this.specificIntervalVal = false;
    this.selectedStageValue = null;
    this.selectedStatusValue = null;
    this.showCharts = false;
    this.selectedQmsDept = [];
    this.annualRefNo = null;
    this.searchByDepartmentCode = null;
    this.selectedIntervalValue = '';
    this.selectedDateRangeValue = '';
    this.selectedAuDateRangeValue = '';
    this.showReportFlagValue = '1';
    this.auditGridFlag = 'default';
  }

  resetFunction1() {
    this.specificIntervalVal = true;
    this.selectedStageValue = null;
    this.selectedStatusValue = null;
    this.showCharts = false;
    this.annualRefNo = null;
    this.searchByDepartmentCode = null;
    this.toDate = new Date();
    this.fromDate = new Date();
    this.fromDate.setDate(this.toDate.getDate() - 365);
    this.selectedIntervalValue = 'MONTH';
    this.selectedDateRangeValue = 'CREATED';
    this.selectedAuDateRangeValue = 'STARTED';
  }
  fieldValidation(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;
      element.style.color = 'red';
    });
  }

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '#005c8a' : 'red';
  }
  genReport() {
    this.ngOnChanges();
    this.findingList = [];
    this.followupList = [];
    this.RecommendationList = [];
    this.severityList = [];
    this.stageList = [];
    this.statusList = [];
    this.baList = [];
    this.departmentList = [];
    this.taskTypeList = [];
    this.activityReportList = [];
    this.inprogressVSTotalList = [];
    this.stageStatusList = [];
    this.tableReportDataList = [];
    this.tempTableReportDataList = [];
    this.extensionTableReportDataList = [];
    this.ecTableReportDataList = [];
    this.actionTableReportDataList = [];
    this.ecList = [];
    this.extensionList = [];
    this.actionList = [];
    this.chartOptionsForFinding = null;
    this.chartOptionsForFollowup = null;
    this.chartOptionsForRecommandation = null;
    this.chartOptionsForSeverity = null;
    this.chartOptionsForStages = null;
    this.chartOptionsForOOSType = null;
    this.chartOptionsForStatus = null;
    this.chartOptionsForBa = null;
    this.chartOptionsForDepartment = null;
    this.chartOptionsForTaskType = null;
    this.chartOptionsForActivity = null;
    this.chartOptionsForActivityInprogressVSTotal = null;
    this.chartOptionsForEC = null;
    this.chartOptionsForExtention = null;
    this.chartOptionsForAction = null;
    this.chartOptionsForStagesStatus = null;
    const validations = [
      { condition: (!this.selectedGroupValue), id: 'groupNameAlert' },
      { condition: (this.specificIntervalVal && !this.fromDate), id: 'fromDateAlert' },
      { condition: (this.specificIntervalVal && !this.toDate), id: 'toDateAlert' },
    ]
    const invalidIds = validations.filter((validation) => validation.condition).map((validation) => validation.id);
    if (invalidIds.length > 0) {
      this.fieldValidation(invalidIds);
    } else if (this.fromDate && this.toDate && (this.toDate < this.fromDate)) {
      alert('To Date cannot be before From Date');
    } else {
      let selectedDateRangeValue = null;
      if (this.qmsservice.moduleName === 'AU') {
        selectedDateRangeValue = this.selectedAuDateRangeValue || null;
      } else {
        selectedDateRangeValue = this.selectedDateRangeValue || null;
      }

      let selectedQmsDept1 = "";
      if (this.selectedQmsDept.length != 0) {
        for (let j = 0; j < this.selectedQmsDept.length; j++) {
          selectedQmsDept1 += this.selectedQmsDept[j];
          selectedQmsDept1 += j == this.selectedQmsDept.length - 1 ? "" : ",";
        }
      }
      let data = {
        groupId: this.selectedGroupValue ? this.selectedGroupValue : null,
        module: this.qmsservice.moduleName,
        dateRangeAt: selectedDateRangeValue,
        fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
        toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
        intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
        stageName: this.selectedStageValue ? this.selectedStageValue : null,
        status: this.selectedStatusValue ? this.selectedStatusValue : null,
        deptCode: selectedQmsDept1 ?? null,
        annualRefNo: this.annualRefNo ?? null,
        refno: this.annualRefNo ?? null,
      }
      this.isProcessing = true;
      const promises = [
        this.appService.getStageReportVal(data),
        this.appService.getStatusReportVal(data),
        this.appService.getBaReportVal(data),
        this.appService.getDepartmentReportVal(data),
        this.appService.getTaskTypeReportVal(data),
        this.appService.getActivityReportVal(data),
        this.appService.getinprogressVSTotalReportVal(data),
        this.appService.getExtensionReportVal(data),
        this.appService.getECReportVal(data),
        this.appService.getActionReportVal(data),
        this.appService.getFindingReportVal(data),
        this.appService.getFollowupReportVal(data),
        this.appService.getRecommendationReportVal(data),
        this.appService.getSeverityReportVal(data),
        this.appService.getDueInDaysReportVal(data),
        this.appService.getOOSTypeVal(data),
      ].map(observable => firstValueFrom(observable)); // Convert each observable to a promise
      // Use Promise.all to wait for all promises to resolve
      Promise.all(promises)
        .then(([stageList, statusList, baList, departmentList, taskTypeList, activityReportList, inprogressVSTotalList, extensionList, ecList, actionList, findingList, followupList, RecommendationList, severityList, dueInDaysList, oosTypeList]) => {
          this.stageList = stageList;
          this.stageExcelList = this.generateGroupSummary(stageList, "stage");
          this.oosTypeList = oosTypeList;
          this.oosTypeExcelList = this.generateGroupSummary(oosTypeList, "oostype");
          this.statusList = statusList;
          this.statusExcelList = this.generateGroupSummary(statusList, "status");
          this.baList = baList;
          this.baExcelList = this.generateGroupSummary(baList, "ba");
          this.departmentList = departmentList;
          this.departmentExcelList = this.generateGroupSummary(departmentList, "dept");
          this.taskTypeList = taskTypeList;
          this.taskTypeExcelList = this.generateGroupSummary(taskTypeList, "ttype");
          this.activityReportList = activityReportList;
          this.inprogressVSTotalList = inprogressVSTotalList;
          this.extensionList = extensionList;
          this.extensionExcelList = this.generateGroupSummary(extensionList, "extention");
          this.ecList = ecList;
          this.ecExcelList = this.generateGroupSummary(ecList, "ec");
          this.actionList = actionList;
          this.actionExcelList = this.generateGroupSummary(actionList, "action");
          this.findingList = findingList;
          this.findingExcelList = this.generateGroupSummary(findingList, "finding");
          this.followupList = followupList;
          this.followupExcelList = this.generateGroupSummary(followupList, "followup");
          this.RecommendationList = RecommendationList;
          this.RecommendationExcelList = this.generateGroupSummary(RecommendationList, "Recommendation");
          this.severityList = severityList;
          this.severityExcelList = this.generateGroupSummary(severityList, "severity");
          this.dueInDaysList = dueInDaysList;
          this.dueInDaysExcelList = this.generateGroupSummary(dueInDaysList, "duein");
          this.createChart();
          this.isProcessing = false;
        },
          error => {
            console.error('Error in forkJoinObservable:', error);
          });
    }
  }
  moveTop() {
    this.showCharts = true;
    setTimeout(() => {
      window.scrollTo({ top: 220, behavior: 'smooth' });
    }, 1000);

  }
  clickedChartVal: any;
  chartDoubleClick(val: any) {
    this.createChartZoom(val);
    this.clickedChartVal = val;
    this.visibleReportPopupForZoom = this.dialog.open(this.reportPopupForZoom, this.reportPopupConfig);
    if (val == 1 || val == 2) {
      this.tableDataListForAll("status", "", "");
      this.clickedType = "Status";
      this.clickedVal = "Status";
      this.clickedStageStatusVal = "";
    } else if (val == 3) {
      this.tableDataListForAll("dep", "", "");
      this.clickedType = "dep";
      this.clickedVal = "dep";
      this.clickedStageStatusVal = "";
    } else if (val == 4) {
      this.tableDataListForAll("ba", "", "");
      this.clickedType = "ba";
      this.clickedVal = "ba";
      this.clickedStageStatusVal = "";
    } else if (val == 5) {
      this.tableDataListForAll("tasktype", "", "");
      this.clickedType = "tasktype";
      this.clickedVal = "tasktype";
      this.clickedStageStatusVal = "";
    } else if (val == 6) {
      this.tableDataListForAll("activity", "", "");
      this.clickedType = "activity";
      this.clickedVal = "activity";
      this.clickedStageStatusVal = "";
    } else if (val == 7) {
      this.tableDataListForAll("extension", "", "");
      this.clickedType = "extension";
      this.clickedVal = "extension";
      this.clickedStageStatusVal = "";
    } else if (val == 8) {
      this.tableDataListForAll("ec", "", "");
      this.clickedType = "ec";
      this.clickedVal = "ec";
      this.clickedStageStatusVal = "";
    } else if (val == 9) {
      this.tableDataListForAll("action", "", "");
      this.clickedType = "action";
      this.clickedVal = "action";
      this.clickedStageStatusVal = "";
    } else if (val == 11) {
      this.tableDataListForAll("finding", "", "");
      this.clickedType = "finding";
      this.clickedVal = "finding";
      this.clickedStageStatusVal = "";
    } else if (val == 14) {
      this.tableDataListForAll("severity", "", "");
      this.clickedType = "severity";
      this.clickedVal = "severity";
      this.clickedStageStatusVal = "";
    } else if (val == 12) {
      this.tableDataListForAll("followup", "", "");
      this.clickedType = "followup";
      this.clickedVal = "followup";
      this.clickedStageStatusVal = "";
    } else if (val == 13) {
      this.tableDataListForAll("recommandation", "", "");
      this.clickedType = "recommandation";
      this.clickedVal = "recommandation";
      this.clickedStageStatusVal = "";
    } else if (val == 15) {
      this.tableDataListForAll("dueInDays", "", "");
      this.clickedType = "dueInDays";
      this.clickedVal = "dueInDays";
      this.clickedStageStatusVal = "";
    }
  }
  createChartZoom(val: any) {
    if (val == 1) {
      this.chartOptionsForStagesZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: "xy",
        toolbar: {
          itemBackgroundColor: "#d3d3d3",
          itemBackgroundColorOnHover: "#3e3e3e",
          buttonBorderColor: "#3e3e3e",
          icon: {
            zoom: {
              backgroundColor: "#007BFF", // Set the background color for the zoom icon
              borderColor: "#007BFF",     // Set the border color for the zoom icon
              borderWidth: 1             // Set the border width for the zoom icon
            }
          }
        },
        legend: {
          cursor: "pointer",
          maxWidth: 370,
          horizontalAlign: "left",
          fontSize: 12,
          fontFamily: "Poppins",
          fontColor: "#0F3659",
          fontWeight: "normal",
        },
        title: {
          text: `Stage (${this.getTotalCountStageChart()})`,
          fontSize: 20,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
          click: function (e: any) {

          }
        },
        data: [{
          type: "pie",
          // color: "red",
          startAngle: -90,
          indexLabel: "{stageName}:{count}",
          showInLegend: true,
          legendText: "{indexLabel}",
          yValueFormatString: "#,###.##''",
          dataPoints: this.getDataPointsForStages(),
          click: this.handleStageChartClick.bind(this) // Reference the click event handler for the entire pie chart

        }]
      };
    }

    if (val == 2) {
      this.chartOptionsForStatusZoom = {
        animationEnabled: true,
        exportEnabled: true,
        legend: {
          cursor: "pointer",
        },
        title: {
          text: `Status (${this.getTotalCount()})`,
          fontSize: 20,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
          click: function (e: any) {

          }
        },
        dataPointMaxWidth: this.statusList.length > 15 ? 20 : 38,
        dataPointMinWidth: this.statusList.length > 15 ? 20 : 38,
        axisY: {
          gridThickness: this.statusList.length === 1 ? 0 : 1,
          gridColor: "#DEEBFE",
          tickLength: this.statusList.length === 1 ? 0 : 5,
          lineThickness: 0,
          labelFontSize: this.statusList.length === 1 ? 0 : 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins",
          lineColor: "#DEEBFE",
          tickColor: "#DEEBFE",
          interval: this.getYAxisInterval(), // Set interval to 1 for whole number increments
          labelFormatter: (e: any) => {
            return this.statusList.length === 1 ? "" : e.value;
          }
        },


        axisX: this.statusList.length === 1 ? {
          tickLength: 0,
          lineThickness: 0,
          labelFontSize: 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins",
          labelFormatter: (e: { label: any; }) => e.label,
          lineColor: "#DEEBFE",
          tickColor: "#DEEBFE"
        } : {
          tickLength: 5,
          lineThickness: 1,
          labelAngle: this.statusList.length > 15 ? -45 : 0,
          interval: 1,
          labelFontSize: 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins",
          labelFormatter: (e: { label: any }) => {
            if (e.label == null) {
              return null;
            }
            if (e.label.length > 10) {
              return e.label.substring(0, 9) + '...';
            }
            return e.label;
          }, lineColor: "#DEEBFE",
          tickColor: "#DEEBFE"
        },
        data: [{
          type: "column",
          color: "#00A6A9",
          indexLabel: "{y}",
          indexLabelFontColor: "#0F3659",
          indexLabelFontSize: 12,
          indexLabelFontFamily: "Poppins",
          dataPoints: this.getDataPointsForStatus(),
          click: this.handleStatusChartClick.bind(this)
        }]
      };
    }

    if (val == 3) {
      this.chartOptionsForDepartmentZoom = {
        animationEnabled: true,
        exportEnabled: true,
        legend: {
          cursor: "pointer",
        },
        title: {
          text: `Department (${this.getTotalCountDepartment()})`,
          fontSize: 20,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
          click: function (e: any) {

          }
        },

        dataPointMaxWidth: this.departmentList.length > 15 ? 20 : 38,
        dataPointMinWidth: this.departmentList.length > 15 ? 20 : 38,
        axisY: {
          gridThickness: this.departmentList.length === 1 ? 0 : 1,
          gridColor: "#DEEBFE",
          tickLength: this.departmentList.length === 1 ? 0 : 5,
          lineThickness: 0,
          labelFontSize: this.departmentList.length === 1 ? 0 : 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins",
          lineColor: "#DEEBFE",
          tickColor: "#DEEBFE",
          interval: this.getYAxisInterval(),
          labelFormatter: (e: any) => {
            return this.departmentList.length === 1 ? "" : e.value;
          }
        },


        axisX: this.departmentList.length === 1 ? {
          tickLength: 0,
          lineThickness: 0,
          labelFontSize: 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins",
          labelFormatter: (e: { label: any; }) => e.label,
          lineColor: "#DEEBFE",
          tickColor: "#DEEBFE"
        } : {
          tickLength: 5,
          lineThickness: 1,
          labelAngle: this.departmentList.length > 15 ? -45 : 0,
          interval: 1,
          labelFontSize: 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins",
          labelFormatter: (e: { label: any }) => {
            let formattedLabel = null;
            if (e.label != null) {
              if (e.label.length > 10) {
                formattedLabel = e.label.substring(0, 9) + '...';
              } else {
                formattedLabel = e.label;
              }
            }
            return formattedLabel;
          }, lineColor: "#DEEBFE",
          tickColor: "#DEEBFE"
        },
        data: [{
          type: "column", // Use "horizontalBar" for horizontal bar chart
          dataPoints: this.getDataPointsForDepartment(),
          color: "#BA7393",
          indexLabel: "{y}",
          indexLabelFontColor: "#0F3659",
          indexLabelFontSize: 12,
          indexLabelFontFamily: "Poppins",
          click: this.handleDepartmentChartClick.bind(this)
        }]
      };
    }
    if (val == 4) {
      this.chartOptionsForBaZoom = {
        animationEnabled: true,
        exportEnabled: true,
        legend: {
          cursor: "pointer",
        },
        title: {
          text: `Bussiness Area (${this.getTotalCountBa()})`,
          fontSize: 20,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
          click: function (e: any) {

          }
        },
        dataPointMaxWidth: this.baList.length > 15 ? 20 : 38,
        dataPointMinWidth: this.baList.length > 15 ? 20 : 38,
        axisY: {
          gridThickness: this.baList.length === 1 ? 0 : 1,
          gridColor: "#DEEBFE",
          tickLength: this.baList.length === 1 ? 0 : 5,
          lineThickness: 0,
          labelFontSize: this.baList.length === 1 ? 0 : 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins",
          lineColor: "#DEEBFE",
          tickColor: "#DEEBFE",
          interval: this.getBaYAxisInterval(),
          labelFormatter: (e: any) => {
            return this.baList.length === 1 ? "" : e.value;
          }
        },


        axisX: this.baList.length === 1 ? {
          tickLength: 0,
          lineThickness: 0,
          labelFontSize: 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins",
          labelFormatter: (e: { label: any; }) => e.label,
          lineColor: "#DEEBFE",
          tickColor: "#DEEBFE"
        } : {
          tickLength: 5,
          lineThickness: 1,
          labelAngle: this.baList.length > 15 ? -45 : 0,
          interval: 1,
          labelFontSize: 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins",
          labelFormatter: (e: { label: any }) => {
            let formattedLabel = null;
            if (e.label != null) {
              if (e.label.length > 10) {
                formattedLabel = e.label.substring(0, 9) + '...';
              } else {
                formattedLabel = e.label;
              }
            }
            return formattedLabel;
          },
          lineColor: "#DEEBFE",
          tickColor: "#DEEBFE"
        },


        data: [{
          type: "column", // Use "horizontalBar" for horizontal bar chart
          color: "#05004E",
          indexLabel: "{y}",
          indexLabelFontColor: "#0F3659",
          indexLabelFontSize: 12,
          indexLabelFontFamily: "Poppins",
          dataPoints: this.getDataPointsForBa(),
          click: this.handleBaChartClick.bind(this)
        }]

      }
    }


    if (val == 5) {
      this.chartOptionsForTaskTypeZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: "xy",
        toolbar: {
          itemBackgroundColor: "#d3d3d3",
          itemBackgroundColorOnHover: "#3e3e3e",
          buttonBorderColor: "#3e3e3e",
          icon: {
            zoom: {
              backgroundColor: "#007BFF", // Set the background color for the zoom icon
              borderColor: "#007BFF",     // Set the border color for the zoom icon
              borderWidth: 1             // Set the border width for the zoom icon
            }
          }
        },
        legend: {
          cursor: "pointer",
          maxWidth: 370,
          horizontalAlign: "left",
          fontSize: 12,
          fontFamily: "Poppins",
          fontColor: "#0F3659",
          fontWeight: "normal",
        },
        title: {
          text: `Task Type (${this.getTotalCountTaskType()})`,
          fontSize: 20,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
          click: function (e: any) {
            // Your title click event handler logic goes here

          }
        },
        data: [{
          type: "doughnut",
          startAngle: -90,
          indexLabel: "{taskType}:{count}",
          showInLegend: true,
          legendText: "{indexLabel}",
          yValueFormatString: "#,###.##''",
          dataPoints: this.getDataPointsForTaskType(),
          click: this.handleTaskTypeChartClick.bind(this) // Reference the click event handler for the entire pie chart

        }]
      };
    }
    if (val == 6) {
      this.chartOptionsForActivityZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: "xy",
        legend: {
          cursor: "pointer",
          horizontalAlign: "left",
          fontSize: 12,
          fontFamily: "Poppins",
          fontColor: "#0F3659",
          fontWeight: "normal",
        },
        title: {
          text: `Activity Report (${this.getTotalCountActivity()})`,
          fontSize: 18,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
        },
        axisX: this.activityReportList.length === 1 ? {
          interval: 1,
          tickLength: 0,
          lineThickness: 0,
          labelFontSize: 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins",
          labelFormatter: (e: { label: any; }) => e.label ? e.label : "",
          lineColor: "#DEEBFE",
          tickColor: "#DEEBFE"
        } : {
          interval: 1,
          tickLength: 5,
          lineThickness: 1,
          labelFontSize: 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins",
          labelFormatter: (e: { label: any; }) => e.label ? e.label : "",
          lineColor: "#DEEBFE",
          tickColor: "#DEEBFE"
        },
        axisY: {
          gridThickness: 1,
          gridColor: "#DEEBFE80",
          tickLength: 0,
          lineThickness: 0,
          labelFontSize: 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins",
          interval: this.getYAxisIntervalForActivity(),
        },
        toolTip: {
          shared: true
        },
        data: [{
          type: "line",
          name: "Activity Report",
          showInLegend: true,
          yValueFormatString: "#,###",
          dataPoints: this.getDataPointsForActivityReport(),
          click: this.handleActivityReportChartClick.bind(this)
        }]
      };
    }

    if (val == 10) {

      this.chartOptionsForActivityInprogressVSTotalZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: "xy",
        legend: {
          cursor: "pointer",
          horizontalAlign: "left",
          fontSize: 12,
          fontFamily: "Poppins",
          fontColor: "#0F3659",
          fontWeight: "normal",
        },
        title: {
          text: `Inprogress Vs Total`,
          fontSize: 18,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
        },
        axisX: {
          interval: 1,
          tickLength: 0,
          lineThickness: 0,
          labelFontSize: 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins"
        },
        axisY: {
          gridThickness: 1,
          gridColor: "#DEEBFE80",
          tickLength: 0,
          lineThickness: 0,
          labelFontSize: 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins"
        },
        toolTip: {
          shared: true
        },
        data: [
          {
            type: "line",
            name: "Avg Time Inprogress",
            showInLegend: true,
            yValueFormatString: "#,###",
            dataPoints: this.dataPointsAvgTimeInprogress()
          },
          {
            type: "line",
            name: "Avg Time Total",
            showInLegend: true,
            yValueFormatString: "#,###",
            dataPoints: this.dataPointsAvgTimeTotal()
          }]
      };

    }
    if (val == 11) {
      this.chartOptionsForFindingZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: "xy",
        toolbar: {
          itemBackgroundColor: "#d3d3d3",
          itemBackgroundColorOnHover: "#3e3e3e",
          buttonBorderColor: "#3e3e3e",
          icon: {
            zoom: {
              backgroundColor: "#007BFF", // Set the background color for the zoom icon
              borderColor: "#007BFF",     // Set the border color for the zoom icon
              borderWidth: 1             // Set the border width for the zoom icon
            }
          }
        },
        legend: {
          cursor: "pointer",
          maxWidth: 370,
          horizontalAlign: "left",
          fontSize: 12,
          fontFamily: "Poppins",
          fontColor: "#0F3659",
          fontWeight: "normal",
        },
        title: {
          text: `Stage (${this.getTotalCountFinding()})`,
          fontSize: 20,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
          click: function (e: any) {

          }
        },
        data: [{
          type: "pie",
          startAngle: -90,
          indexLabel: "{status}:{count}",
          showInLegend: true,
          legendText: "{indexLabel}",
          yValueFormatString: "#,###.##''",
          dataPoints: this.getDataPointsForFinding(),
          click: this.handleFindingChartClick.bind(this)

        }]
      };

    }
    if (val == 12) {
      this.chartOptionsForFollowupZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: "xy",
        toolbar: {
          itemBackgroundColor: "#d3d3d3",
          itemBackgroundColorOnHover: "#3e3e3e",
          buttonBorderColor: "#3e3e3e",
          icon: {
            zoom: {
              backgroundColor: "#007BFF", // Set the background color for the zoom icon
              borderColor: "#007BFF",     // Set the border color for the zoom icon
              borderWidth: 1             // Set the border width for the zoom icon
            }
          }
        },
        legend: {
          cursor: "pointer",
          maxWidth: 370,
          horizontalAlign: "left",
          fontSize: 12,
          fontFamily: "Poppins",
          fontColor: "#0F3659",
          fontWeight: "normal",
        },
        title: {
          text: `Followup Status (${this.getTotalCountFolloup()})`,
          fontSize: 20,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
          click: function (e: any) {
          }
        },
        data: [{
          type: "pie",
          startAngle: -90,
          indexLabel: "{status}:{count}",
          showInLegend: true,
          legendText: "{indexLabel}",
          yValueFormatString: "#,###.##''",
          dataPoints: this.getDataPointsForFollowup(),
          click: this.handleFolloupChartClick.bind(this)

        }]
      };

    }
    if (val == 13) {
      this.chartOptionsForRecommandationZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: "xy",
        toolbar: {
          itemBackgroundColor: "#d3d3d3",
          itemBackgroundColorOnHover: "#3e3e3e",
          buttonBorderColor: "#3e3e3e",
          icon: {
            zoom: {
              backgroundColor: "#007BFF", // Set the background color for the zoom icon
              borderColor: "#007BFF",     // Set the border color for the zoom icon
              borderWidth: 1             // Set the border width for the zoom icon
            }
          }
        },
        legend: {
          cursor: "pointer",
          maxWidth: 370,
          horizontalAlign: "left",
          fontSize: 12,
          fontFamily: "Poppins",
          fontColor: "#0F3659",
          fontWeight: "normal",
        },
        title: {
          text: "Recommendation Count",
          fontSize: 20,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
          click: function (e: any) {

          }
        },
        data: [{
          type: "pie",
          startAngle: -90,
          indexLabel: "{status}:{count}",
          showInLegend: true,
          legendText: "{indexLabel}",
          yValueFormatString: "#,###.##''",
          dataPoints: this.getDataPointsForRecommandation(),
          click: this.handleRecommandationChartClick.bind(this)
        }]
      };
    }
    if (val == 14) {
      this.chartOptionsForSeverityZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: "xy",
        toolbar: {
          itemBackgroundColor: "#d3d3d3",
          itemBackgroundColorOnHover: "#3e3e3e",
          buttonBorderColor: "#3e3e3e",
          icon: {
            zoom: {
              backgroundColor: "#007BFF", // Set the background color for the zoom icon
              borderColor: "#007BFF",     // Set the border color for the zoom icon
              borderWidth: 1             // Set the border width for the zoom icon
            }
          }
        },
        legend: {
          cursor: "pointer",
          maxWidth: 370,
          horizontalAlign: "left",
          fontSize: 12,
          fontFamily: "Poppins",
          fontColor: "#0F3659",
          fontWeight: "normal",
        },
        title: {
          text: `Finding severity (${this.getTotalCountSeverity()})`,
          fontSize: 20,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
          click: function (e: any) {

          }
        },
        data: [{
          type: "pie",
          startAngle: -90,
          indexLabel: "{severity}:{count}",
          showInLegend: true,
          legendText: "{indexLabel}",
          yValueFormatString: "#,###.##''",
          dataPoints: this.getDataPointsForSeverity(),
          click: this.handleSeverityChartClick.bind(this)

        }]
      };
    }
    if (val == 7) {
      this.chartOptionsForExtentionZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: "xy",
        legend: {
          cursor: "pointer",
          horizontalAlign: "left",
          fontSize: 12,
          fontFamily: "Poppins",
          fontColor: "#0F3659",
          fontWeight: "normal",
        },
        title: {
          text: `Extension (${this.getTotalCountExtension()})`,
          fontSize: 18,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
        },
        axisX: this.extensionList.length === 1 ? {
          interval: 1,
          tickLength: 0,
          lineThickness: 0,
          labelFontSize: 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins",
          labelFormatter: (e: { label: any; }) => e.label ? e.label : "",
          lineColor: "#DEEBFE",
          tickColor: "#DEEBFE"
        } : {
          interval: 1,
          tickLength: 5,
          lineThickness: 1,
          labelFontSize: 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins",
          labelFormatter: (e: { label: any; }) => e.label ? e.label : "",
          lineColor: "#DEEBFE",
          tickColor: "#DEEBFE"
        },
        // to remove horizontal lines
        axisY: {
          gridThickness: 1,
          gridColor: "#DEEBFE80",
          tickLength: 0,
          lineThickness: 0,
          labelFontSize: 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins",
          interval: this.getYAxisIntervalForExtension(),
        },
        toolTip: {
          shared: true
        },
        data: [{
          type: "line",
          name: "Extension",
          showInLegend: true,
          yValueFormatString: "#,###",
          dataPoints: this.getDataPointsForExtension(),
          click: this.handleExtensionChartClick.bind(this)
        }]
      };
    }

    if (val == 8) {
      this.chartOptionsForECZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: "xy",
        legend: {
          cursor: "pointer",
          horizontalAlign: "left",
          fontSize: 12,
          fontFamily: "Poppins",
          fontColor: "#0F3659",
          fontWeight: "normal",
        },
        title: {
          text: `EC (${this.getTotalCountEc()})`,
          fontSize: 18,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
        },
        axisX: this.ecList.length === 1 ? {
          interval: 1,
          tickLength: 0,
          lineThickness: 0,
          labelFontSize: 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins",
          labelFormatter: (e: { label: any; }) => e.label ? e.label : "",
          lineColor: "#DEEBFE",
          tickColor: "#DEEBFE"
        } : {
          interval: 1,
          tickLength: 5,
          lineThickness: 1,
          labelFontSize: 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins",
          labelFormatter: (e: { label: any; }) => e.label ? e.label : "",
          lineColor: "#DEEBFE",
          tickColor: "#DEEBFE"
        },
        // to remove horizontal lines
        axisY: {
          gridThickness: 1,
          gridColor: "#DEEBFE80",
          tickLength: 0,
          lineThickness: 0,
          labelFontSize: 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins",
          interval: this.getYAxisIntervalForEc(),
        },
        toolTip: {
          shared: true
        },
        data: [{
          type: "line",
          name: "EC",
          yValueFormatString: "#,###",
          dataPoints: this.getDataPointsForEC(),
          click: this.handleECChartClick.bind(this)
        }]
      };
    }

    if (val == 9) {
      this.chartOptionsForActionZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: "xy",
        legend: {
          cursor: "pointer",
          horizontalAlign: "left",
          fontSize: 12,
          fontFamily: "Poppins",
          fontColor: "#0F3659",
          fontWeight: "normal",
        },
        title: {
          text: `Action (${this.getTotalCountAction()})`,
          fontSize: 18,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
        },
        axisX: this.actionList.length === 1 ? {
          interval: 1,
          tickLength: 0,
          lineThickness: 0,
          labelFontSize: 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins",
          labelFormatter: (e: { label: any; }) => e.label ? e.label : "",
          lineColor: "#DEEBFE",
          tickColor: "#DEEBFE"
        } : {
          interval: 1,
          tickLength: 5,
          lineThickness: 1,
          labelFontSize: 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins",
          labelFormatter: (e: { label: any; }) => e.label ? e.label : "",
          lineColor: "#DEEBFE",
          tickColor: "#DEEBFE"
        },
        // to remove horizontal lines
        axisY: {
          gridThickness: 1,
          gridColor: "#DEEBFE80",
          tickLength: 0,
          lineThickness: 0,
          labelFontSize: 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins",
          interval: this.getYAxisIntervalForAction(),
        },
        toolTip: {
          shared: true
        },

        data: [{
          type: "line",
          name: "Action",
          yValueFormatString: "#,###",
          dataPoints: this.getDataPointsForAction(),
          click: this.handleActionChartClick.bind(this)
        }]
      };
    }
    if (val == 15) {
      this.chartOptionsForDueInDaysZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: "xy",
        toolbar: {
          itemBackgroundColor: "#d3d3d3",
          itemBackgroundColorOnHover: "#3e3e3e",
          buttonBorderColor: "#3e3e3e",
          icon: {
            zoom: {
              backgroundColor: "#007BFF", // Set the background color for the zoom icon
              borderColor: "#007BFF",     // Set the border color for the zoom icon
              borderWidth: 1             // Set the border width for the zoom icon
            }
          }
        },
        legend: {
          cursor: "pointer",
          maxWidth: 370,
          horizontalAlign: "left",
          fontSize: 12,
          fontFamily: "Poppins",
          fontColor: "#0F3659",
          fontWeight: "normal",
        },
        title: {
          text: `Due In Days (${this.getTotalCountDueInDays()})`,
          fontSize: 20,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
          click: function (e: any) {
            // Your title click event handler logic goes here

          }
        },
        data: [{
          type: "pie",
          startAngle: -90,
          indexLabel: "{dueInDays}:{count}",
          showInLegend: true,
          legendText: "{indexLabel}",
          yValueFormatString: "#,###.##''",
          dataPoints: this.getDataPointsForDueInDays(),
          click: this.handleDueInDaysChartClick.bind(this)

        }]
      };
    }


  }
  getYAxisInterval() {
    const maxValue = Math.max(...this.statusList.map((item: { count: number }) => item.count));
    if (maxValue <= 5) {
      return 1;
    } else if (maxValue <= 10) {
      return 2;
    } else if (maxValue <= 50) {
      return 5;
    } else if (maxValue <= 100) {
      return 10;
    } else if (maxValue <= 500) {
      return 50;
    } else if (maxValue <= 1000) {
      return 100;
    } else {
      return 200; // Adjust based on your data range
    }
  };

  getDaYAxisInterval() {
    const maxValue = Math.max(...this.departmentList.map((item: { count: number }) => item.count));
    if (maxValue <= 5) {
      return 1;
    } else if (maxValue <= 10) {
      return 2;
    } else if (maxValue <= 50) {
      return 5;
    } else if (maxValue <= 100) {
      return 10;
    } else if (maxValue <= 500) {
      return 50;
    } else if (maxValue <= 1000) {
      return 100;
    } else {
      return 200; // Adjust based on your data range
    }
  };

  getYAxisIntervalForActivity() {
    const maxValue = Math.max(...this.activityReportList.map((item: { count: number }) => item.count));
    if (maxValue <= 5) {
      return 1;
    } else if (maxValue <= 10) {
      return 2;
    } else if (maxValue <= 50) {
      return 5;
    } else if (maxValue <= 100) {
      return 10;
    } else if (maxValue <= 500) {
      return 50;
    } else if (maxValue <= 1000) {
      return 100;
    } else {
      return 200; // Adjust based on your data range
    }
  };

  getYAxisIntervalForExtension() {
    const maxValue = Math.max(...this.extensionList.map((item: { count: number }) => item.count));
    if (maxValue <= 5) {
      return 1;
    } else if (maxValue <= 10) {
      return 2;
    } else if (maxValue <= 50) {
      return 5;
    } else if (maxValue <= 100) {
      return 10;
    } else if (maxValue <= 500) {
      return 50;
    } else if (maxValue <= 1000) {
      return 100;
    } else {
      return 200; // Adjust based on your data range
    }
  };

  getYAxisIntervalForEc() {
    const maxValue = Math.max(...this.ecList.map((item: { count: number }) => item.count));
    if (maxValue <= 5) {
      return 1;
    } else if (maxValue <= 10) {
      return 2;
    } else if (maxValue <= 50) {
      return 5;
    } else if (maxValue <= 100) {
      return 10;
    } else if (maxValue <= 500) {
      return 50;
    } else if (maxValue <= 1000) {
      return 100;
    } else {
      return 200; // Adjust based on your data range
    }
  };
  getYAxisIntervalForAction() {
    const maxValue = Math.max(...this.actionList.map((item: { count: number }) => item.count));
    if (maxValue <= 5) {
      return 1;
    } else if (maxValue <= 10) {
      return 2;
    } else if (maxValue <= 50) {
      return 5;
    } else if (maxValue <= 100) {
      return 10;
    } else if (maxValue <= 500) {
      return 50;
    } else if (maxValue <= 1000) {
      return 100;
    } else {
      return 200; // Adjust based on your data range
    }
  };

  getBaYAxisInterval() {
    const maxValue = Math.max(...this.baList.map((item: { cnt: number }) => item.cnt));
    if (maxValue <= 5) {
      return 1;
    } else if (maxValue <= 10) {
      return 2;
    } else if (maxValue <= 50) {
      return 5;
    } else if (maxValue <= 100) {
      return 10;
    } else if (maxValue <= 500) {
      return 50;
    } else if (maxValue <= 1000) {
      return 100;
    } else {
      return 200; // Adjust based on your data range
    }
  };
  createChart() {
    this.chartOptionsForOOSType = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      toolbar: {
        itemBackgroundColor: "#d3d3d3",
        itemBackgroundColorOnHover: "#3e3e3e",
        buttonBorderColor: "#3e3e3e",
        icon: {
          zoom: {
            backgroundColor: "#007BFF", // Set the background color for the zoom icon
            borderColor: "#007BFF",     // Set the border color for the zoom icon
            borderWidth: 1             // Set the border width for the zoom icon
          }
        }
      },
      legend: {
        cursor: "pointer",
        maxWidth: 370,
        // itemWidth: 150,
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      title: {
        text: `OOS Type (${this.getTotalCountOOSTypeChart()})`,
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          // Your title click event handler logic goes here

        }
      },
      data: [{
        type: "pie",
        // color: "red",
        startAngle: -90,
        indexLabel: "{taskType}:{count}",
        showInLegend: true,
        legendText: "{indexLabel}",
        yValueFormatString: "#,###.##''",
        dataPoints: this.getDataPointsForOOSType(),
        click: this.handleOOSTypeChartClick.bind(this) // Reference the click event handler for the entire pie chart
      }]
    };
    this.chartOptionsForStages = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      toolbar: {
        itemBackgroundColor: "#d3d3d3",
        itemBackgroundColorOnHover: "#3e3e3e",
        buttonBorderColor: "#3e3e3e",
        icon: {
          zoom: {
            backgroundColor: "#007BFF", // Set the background color for the zoom icon
            borderColor: "#007BFF",     // Set the border color for the zoom icon
            borderWidth: 1             // Set the border width for the zoom icon
          }
        }
      },
      legend: {
        cursor: "pointer",
        maxWidth: 370,
        // itemWidth: 150,
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      title: {
        text: `Stage (${this.getTotalCountStageChart()})`,
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          // Your title click event handler logic goes here

        }
      },
      data: [{
        type: "pie",
        // color: "red",
        startAngle: -90,
        indexLabel: "{stageName}:{count}",
        showInLegend: true,
        legendText: "{indexLabel}",
        yValueFormatString: "#,###.##''",
        dataPoints: this.getDataPointsForStages(),
        click: this.handleStageChartClick.bind(this) // Reference the click event handler for the entire pie chart
      }]
    };
    this.chartOptionsForFinding = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      toolbar: {
        itemBackgroundColor: "#d3d3d3",
        itemBackgroundColorOnHover: "#3e3e3e",
        buttonBorderColor: "#3e3e3e",
        icon: {
          zoom: {
            backgroundColor: "#007BFF", // Set the background color for the zoom icon
            borderColor: "#007BFF",     // Set the border color for the zoom icon
            borderWidth: 1             // Set the border width for the zoom icon
          }
        }
      },
      legend: {
        cursor: "pointer",
        maxWidth: 370,
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      title: {
        text: `Finding Status (${this.getTotalCountFinding()})`,
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          // Your title click event handler logic goes here

        }
      },
      data: [{
        type: "pie",
        startAngle: -90,
        indexLabel: "{status}:{count}",
        showInLegend: true,
        legendText: "{indexLabel}",
        yValueFormatString: "#,###.##''",
        dataPoints: this.getDataPointsForFinding(),
        click: this.handleFindingChartClick.bind(this)

      }]
    };
    this.chartOptionsForFollowup = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      toolbar: {
        itemBackgroundColor: "#d3d3d3",
        itemBackgroundColorOnHover: "#3e3e3e",
        buttonBorderColor: "#3e3e3e",
        icon: {
          zoom: {
            backgroundColor: "#007BFF", // Set the background color for the zoom icon
            borderColor: "#007BFF",     // Set the border color for the zoom icon
            borderWidth: 1             // Set the border width for the zoom icon
          }
        }
      },
      legend: {
        cursor: "pointer",
        maxWidth: 370,
        // itemWidth: 150,
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      title: {
        text: `Followup Status (${this.getTotalCountFolloup()})`,
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          // Your title click event handler logic goes here

        }
      },
      data: [{
        type: "pie",
        startAngle: -90,
        indexLabel: "{status}:{count}",
        showInLegend: true,
        legendText: "{indexLabel}",
        yValueFormatString: "#,###.##''",
        dataPoints: this.getDataPointsForFollowup(),
        click: this.handleFolloupChartClick.bind(this)

      }]
    };
    this.chartOptionsForRecommandation = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      toolbar: {
        itemBackgroundColor: "#d3d3d3",
        itemBackgroundColorOnHover: "#3e3e3e",
        buttonBorderColor: "#3e3e3e",
        icon: {
          zoom: {
            backgroundColor: "#007BFF", // Set the background color for the zoom icon
            borderColor: "#007BFF",     // Set the border color for the zoom icon
            borderWidth: 1             // Set the border width for the zoom icon
          }
        }
      },
      legend: {
        cursor: "pointer",
        maxWidth: 370,
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      title: {
        text: "Recommendation Count",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {

        }
      },
      data: [{
        type: "pie",
        startAngle: -90,
        indexLabel: "{status}:{count}",
        showInLegend: true,
        legendText: "{indexLabel}",
        yValueFormatString: "#,###.##''",
        dataPoints: this.getDataPointsForRecommandation(),
        click: this.handleRecommandationChartClick.bind(this)

      }]
    };
    this.chartOptionsForSeverity = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      toolbar: {
        itemBackgroundColor: "#d3d3d3",
        itemBackgroundColorOnHover: "#3e3e3e",
        buttonBorderColor: "#3e3e3e",
        icon: {
          zoom: {
            backgroundColor: "#007BFF", // Set the background color for the zoom icon
            borderColor: "#007BFF",     // Set the border color for the zoom icon
            borderWidth: 1             // Set the border width for the zoom icon
          }
        }
      },
      legend: {
        cursor: "pointer",
        maxWidth: 370,
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      title: {
        text: `Finding severity (${this.getTotalCountSeverity()})`,
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          // Your title click event handler logic goes here

        }
      },
      data: [{
        type: "pie",
        startAngle: -90,
        indexLabel: "{severity}:{count}",
        showInLegend: true,
        legendText: "{indexLabel}",
        yValueFormatString: "#,###.##''",
        dataPoints: this.getDataPointsForSeverity(),
        click: this.handleSeverityChartClick.bind(this)

      }]
    };
    this.chartOptionsForStatus = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: `Status (${this.getTotalCount()})`,
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold"
      },
      dataPointMaxWidth: this.statusList.length > 15 ? 20 : 38,
      dataPointMinWidth: this.statusList.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.statusList.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.statusList.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.statusList.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getYAxisInterval(),
        labelFormatter: (e: any) => {
          return this.statusList.length === 1 ? "" : e.value;
        }
      },


      axisX: this.statusList.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.statusList.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column",
        color: "#00A6A9",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        dataPoints: this.getDataPointsForStatus(),
        click: this.handleStatusChartClick.bind(this)
      }],
      toolTip: {
        enabled: true,
        content: "{label}: {y}"
      }
    };

    this.chartOptionsForBa = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: `Bussiness Area (${this.getTotalCountBa()})`,
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {

        }
      },
      dataPointMaxWidth: this.baList.length > 15 ? 20 : 38,
      dataPointMinWidth: this.baList.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.baList.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.baList.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.baList.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getBaYAxisInterval(),
        labelFormatter: (e: any) => {
          return this.baList.length === 1 ? "" : e.value;
        }
      },


      axisX: this.baList.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.baList.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        color: "#05004E",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        dataPoints: this.getDataPointsForBa(),
        click: this.handleBaChartClick.bind(this)
      }]
    };


    this.chartOptionsForDepartment = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: `Department (${this.getTotalCountDepartment()})`,
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {

        }
      },
      dataPointMaxWidth: this.departmentList.length > 15 ? 20 : 38,
      dataPointMinWidth: this.departmentList.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.departmentList.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.departmentList.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.departmentList.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getDaYAxisInterval(),
        labelFormatter: (e: any) => {
          return this.departmentList.length === 1 ? "" : e.value;
        }
      },
      axisX: this.departmentList.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.departmentList.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        dataPoints: this.getDataPointsForDepartment(),
        color: "#BA7393",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        click: this.handleDepartmentChartClick.bind(this)
      }]
    };

    this.chartOptionsForTaskType = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      toolbar: {
        itemBackgroundColor: "#d3d3d3",
        itemBackgroundColorOnHover: "#3e3e3e",
        buttonBorderColor: "#3e3e3e",
        icon: {
          zoom: {
            backgroundColor: "#007BFF", // Set the background color for the zoom icon
            borderColor: "#007BFF",     // Set the border color for the zoom icon
            borderWidth: 1             // Set the border width for the zoom icon
          }
        }
      },
      legend: {
        cursor: "pointer",
        maxWidth: 370,
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      title: {
        text: `Task Type (${this.getTotalCountTaskType()})`,
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          // Your title click event handler logic goes here

        }
      },
      data: [{
        type: "doughnut",
        startAngle: -90,
        indexLabel: "{taskType}:{count}",
        showInLegend: true,
        legendText: "{indexLabel}",
        yValueFormatString: "#,###.##''",
        dataPoints: this.getDataPointsForTaskType(),
        click: this.handleTaskTypeChartClick.bind(this) // Reference the click event handler for the entire pie chart

      }]
    };
    this.chartOptionsForDueInDays = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      toolbar: {
        itemBackgroundColor: "#d3d3d3",
        itemBackgroundColorOnHover: "#3e3e3e",
        buttonBorderColor: "#3e3e3e",
        icon: {
          zoom: {
            backgroundColor: "#007BFF", // Set the background color for the zoom icon
            borderColor: "#007BFF",     // Set the border color for the zoom icon
            borderWidth: 1             // Set the border width for the zoom icon
          }
        }
      },
      legend: {
        cursor: "pointer",
        maxWidth: 370,
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      title: {
        text: `Due In Days (${this.getTotalCountDueInDays()})`,
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          // Your title click event handler logic goes here

        }
      },
      data: [{
        type: "pie",
        startAngle: -90,
        indexLabel: "{dueInDays}:{count}",
        showInLegend: true,
        legendText: "{indexLabel}",
        yValueFormatString: "#,###.##''",
        dataPoints: this.getDataPointsForDueInDays(),
        click: this.handleDueInDaysChartClick.bind(this)

      }]
    }

    this.chartOptionsForActivity = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      legend: {
        cursor: "pointer",
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      title: {
        text: `Activity Report (${this.getTotalCountActivity()})`,
        fontSize: 18,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
      },
      axisX: this.activityReportList.length === 1 ? {
        interval: 1,
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label ? e.label : "",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        interval: 1,
        tickLength: 5,
        lineThickness: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label ? e.label : "",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      // to remove horizontal lines
      axisY: {
        gridThickness: 1,
        gridColor: "#DEEBFE80",
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        interval: this.getYAxisIntervalForActivity(),
      },
      toolTip: {
        shared: true
      },
      data: [{
        type: "line",
        name: "Activity Report",
        showInLegend: true,
        yValueFormatString: "#,###",
        dataPoints: this.getDataPointsForActivityReport(),
        click: this.handleActivityReportChartClick.bind(this)
      }]
    };

    this.chartOptionsForActivityInprogressVSTotal = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      legend: {
        cursor: "pointer",
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      title: {
        text: "Inprogress Vs Total",
        fontSize: 18,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
      },
      axisX: {
        interval: 1,
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins"
      },
      // to remove horizontal lines
      axisY: {
        gridThickness: 1,
        gridColor: "#DEEBFE80",
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins"
      },
      toolTip: {
        shared: true
      },
      data: [
        {

          type: "line",
          name: "Avg Time Inprogress",
          showInLegend: true,
          yValueFormatString: "#,###",
          dataPoints: this.dataPointsAvgTimeInprogress(),
          // click: this.handleAvgTimeInprogressChartClick.bind(this)
        },
        {
          type: "line",
          name: "Avg Time Total",
          showInLegend: true,
          yValueFormatString: "#,###",
          dataPoints: this.dataPointsAvgTimeTotal(),
          // click: this.handleAvgTimeTotalChartClick.bind(this)
        }]
    };


    this.chartOptionsForExtention = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      legend: {
        cursor: "pointer",
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      title: {
        text: `Extension (${this.getTotalCountExtension()})`,
        fontSize: 18,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
      },
      axisX: this.extensionList.length === 1 ? {
        interval: 1,
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label ? e.label : "",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        interval: 1,
        tickLength: 5,
        lineThickness: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label ? e.label : "",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      // to remove horizontal lines
      axisY: {
        gridThickness: 1,
        gridColor: "#DEEBFE80",
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        interval: this.getYAxisIntervalForExtension(),
      },
      toolTip: {
        shared: true
      },
      data: [{
        type: "line",
        name: "Extension",
        showInLegend: true,
        yValueFormatString: "#,###",
        dataPoints: this.getDataPointsForExtension(),
        click: this.handleExtensionChartClick.bind(this)
      }]
    };



    this.chartOptionsForEC = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      legend: {
        cursor: "pointer",
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      title: {
        text: `EC (${this.getTotalCountEc()})`,
        fontSize: 18,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
      },
      axisX: this.ecList.length === 1 ? {
        interval: 1,
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label ? e.label : "",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        interval: 1,
        tickLength: 5,
        lineThickness: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label ? e.label : "",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      // to remove horizontal lines
      axisY: {
        gridThickness: 1,
        gridColor: "#DEEBFE80",
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        interval: this.getYAxisIntervalForEc(),
      },
      toolTip: {
        shared: true
      },
      data: [{
        type: "line",
        name: "EC",
        yValueFormatString: "#,###",
        dataPoints: this.getDataPointsForEC(),
        click: this.handleECChartClick.bind(this)
      }]
    };

    this.chartOptionsForAction = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      legend: {
        cursor: "pointer",
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      title: {
        text: `Action (${this.getTotalCountAction()})`,
        fontSize: 18,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
      },
      axisX: this.actionList.length === 1 ? {
        interval: 1,
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label ? e.label : "",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        interval: 1,
        tickLength: 5,
        lineThickness: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label ? e.label : "",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      // to remove horizontal lines
      axisY: {
        gridThickness: 1,
        gridColor: "#DEEBFE80",
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        interval: this.getYAxisIntervalForAction(),
      },
      toolTip: {
        shared: true
      },

      data: [{
        type: "line",
        name: "Action",
        yValueFormatString: "#,###",
        dataPoints: this.getDataPointsForAction(),
        click: this.handleActionChartClick.bind(this)
      }]
    };
    this.moveTop();
  }


  subChart() {
    this.chartOptionsForStagesStatus = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: `Status(${this.getTotalCountStageStatus()})`,
        click: function (e: any) {
          // Your title click event handler logic goes here

        }
      },
      data: [{
        type: "pie",
        startAngle: -90,
        indexLabel: "{status}: {count}",
        yValueFormatString: "#,###.##''",
        dataPoints: this.getDataPointsForStageStatus(),
        click: this.handleStageStatusChartClick.bind(this) // Reference the click event handler for the entire pie chart
      }]
    };
  }

  getDataPointsForOOSType() {
    const dataPoints = this.oosTypeList.map((ty: { count: any; taskType: any; }, index: any) => ({
      y: ty.count,
      indexLabel: `${ty.taskType}:${ty.count}`,
      color: this.colorMethod(ty.taskType, index)
    }));
    return dataPoints;
  }

  getDataPointsForStages() {
    const dataPoints = this.stageList.map((stage: { count: any; stageName: any; }, index: any) => ({
      y: stage.count,
      indexLabel: `${stage.stageName}:${stage.count}`,
      color: this.colorMethod(stage.stageName, index)
    }));
    return dataPoints;
  }
  getDataPointsForFinding() {
    const dataPoints = this.findingList.map((finding: { count: any; status: any; }, index: any) => ({
      y: finding.count,
      indexLabel: `${finding.status}:${finding.count}`,
      color: this.colorMethod(finding.status, index)
    }));
    return dataPoints;
  }
  getDataPointsForFollowup() {
    const dataPoints = this.followupList.map((followup: { count: any; status: any; }, index: any) => ({
      y: followup.count,
      indexLabel: `${followup.status}:${followup.count}`,
      color: this.colorMethod(followup.status, index)
    }));
    return dataPoints;
  }
  getDataPointsForDueInDays() {
    const dataPoints = this.dueInDaysList.map((dueInDays: { count: any; dueInDays: any; }, index: any) => ({
      y: dueInDays.count,
      indexLabel: `${dueInDays.dueInDays}:${dueInDays.count}`,
      color: this.colorMethod(dueInDays.dueInDays, index)
    }));
    return dataPoints;
  }
  getDataPointsForRecommandation() {
    const dataPoints = this.RecommendationList.map((recommendation: { count: any; }, index: any) => ({
      y: recommendation.count,
      indexLabel: `${recommendation.count}`,
      color: this.colorMethod(recommendation.count, index)
    }));
    return dataPoints;
  }
  getDataPointsForSeverity() {
    const dataPoints = this.severityList.map((severity: { count: any; severity: any; }, index: any) => ({
      y: severity.count,
      indexLabel: `${severity.severity}:${severity.count}`,
      color: this.colorMethod(severity.severity, index)
    }));
    return dataPoints;
  }
  getDataPointsForStatus() {
    const dataPoints = this.statusList.map((statu: { count: any; status: any; }) => ({
      label: `${statu.status}`,
      y: statu.count
    }));
    return dataPoints;
  }
  getDataPointsForStageStatus() {
    const dataPoints = this.stageStatusList.map((statu: { count: any; status: any; color: any }, index: any) => ({
      y: statu.count,
      indexLabel: `${statu.status} : ${statu.count}`,
      color: this.colorMethod(statu.status, index)

    }));
    return dataPoints;
  }



  getDataPointsForBa() {
    const dataPoints = this.baList.map((ba: { cnt: any; baValue: any; }) => ({
      label: `${ba.baValue}`,
      y: ba.cnt

    }));
    return dataPoints;
  }

  getDataPointsForDepartment() {
    // Transform your data into CanvasJS dataPoints format
    const dataPoints = this.departmentList.map((dep: { count: any; deptCode: any; }) => ({
      label: `${dep.deptCode}`,
      y: dep.count
    }));
    return dataPoints;
  }

  getDataPointsForTaskType() {
    // Transform your data into CanvasJS dataPoints format
    const dataPoints = this.taskTypeList.map((tasktypes: { count: any; taskType: any; }, index: any) => ({
      y: tasktypes.count,
      indexLabel: `${tasktypes.taskType}: ${tasktypes.count}`,
      color: this.colorMethod(tasktypes.taskType, index)
    }));
    return dataPoints;
  }

  getDataPointsForActivityReport() {
    // Transform your data into CanvasJS dataPoints format
    const dataPoints = this.activityReportList.map((item: { axisValue: any; count: any; }) => ({
      label: item.axisValue,
      y: item.count
    }));
    return dataPoints;
  }
  dataPointsAvgTimeTotal() {
    const dataPointsAvgTimeTotal = this.inprogressVSTotalList.map((item: { axisValue: any; avgTimeTakenAtTotal: any; }) => ({
      label: item.axisValue,
      y: item.avgTimeTakenAtTotal
    }));
    return dataPointsAvgTimeTotal;
  }
  dataPointsAvgTimeInprogress() {
    const dataPointsAvgTimeInprogress = this.inprogressVSTotalList.map((item: { axisValue: any; avgTimeTakenAtInprogress: any; }) => ({
      label: item.axisValue,
      y: item.avgTimeTakenAtInprogress
    }));
    return dataPointsAvgTimeInprogress;
  }
  getDataPointsForExtension() {
    // Transform your data into CanvasJS dataPoints format
    const dataPoints = this.extensionList.map((item: { axisValue: any; count: any; }) => ({
      label: item.axisValue,
      y: item.count
    }));
    return dataPoints;
  }

  getDataPointsForEC() {
    // Transform your data into CanvasJS dataPoints format
    const dataPoints = this.ecList.map((item: { axisValue: any; count: any; }) => ({
      label: item.axisValue,
      y: item.count
    }));
    return dataPoints;
  }

  getDataPointsForAction() {
    // Transform your data into CanvasJS dataPoints format
    const dataPoints = this.actionList.map((item: { axisValue: any; count: any; }) => ({
      label: item.axisValue,
      y: item.count
    }));
    return dataPoints;
  }
  handleStageChartClick(e: any): void {
    this.stageStatusList = this.statusList?.filter((status: any) => status.stageName.includes(this.stageList[e.dataPointIndex].stageName));
    this.titleName = "Stage - Status Report"
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
    this.subChart();
    this.tableDataList("stage", this.stageList[e.dataPointIndex].stageName, "");
    this.clickedType = "Stage";
    this.clickedVal = this.stageList[e.dataPointIndex].stageName;
    this.clickedStageStatusVal = this.stageList[e.dataPointIndex].stageName;
  }

  handleOOSTypeChartClick(e: any): void {
    this.titleName = "OOS Type"
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
    this.tableDataList("oosType", this.oosTypeList[e.dataPointIndex].taskType, "");
    this.clickedType = "oosType";
    this.clickedVal = this.oosTypeList[e.dataPointIndex].taskType;
    this.clickedStageStatusVal = "";
  }
  getTotalCountStageChart() {
    return this.stageList.reduce((total: number, item: { count: number }) => total + item.count, 0);
  }
  getTotalCountOOSTypeChart() {
    return this.oosTypeList.reduce((total: number, item: { count: number }) => total + item.count, 0);
  }
  cancelReportPopupFunction() {
    this.visibleReportPopup.close();
  }
  cancelReportPopupForZoomFunction() {
    this.visibleReportPopupForZoom.close();
    this.showReportFlagValue = "";
  }
  handleFindingChartClick(e: any): void {
    this.titleName = "Finding Status"
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
    this.tableDataList("finding", this.findingList[e.dataPointIndex].status, "");
    this.clickedType = "Finding";
    this.clickedVal = this.findingList[e.dataPointIndex].status;
    this.clickedStageStatusVal = this.findingList[e.dataPointIndex].status;
  }
  getTotalCountFinding() {
    return this.findingList.reduce((total: number, item: { count: number }) => total + item.count, 0);
  }
  handleFolloupChartClick(e: any): void {
    this.titleName = "Followup Status"
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
    this.tableDataList("followup", this.followupList[e.dataPointIndex].status, "");
    this.clickedType = "Followup";
    this.clickedVal = this.followupList[e.dataPointIndex].status;
    this.clickedStageStatusVal = "";
  }
  getTotalCountFolloup() {
    return this.followupList.reduce((total: number, item: { count: number }) => total + item.count, 0);
  }
  handleDueInDaysChartClick(e: any): void {
    this.titleName = "Due In Days"
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
    this.tableDataList("dueInDays", this.dueInDaysList[e.dataPointIndex].dueInDays, "");
    this.clickedType = "Due In Days";
    this.clickedVal = this.dueInDaysList[e.dataPointIndex].dueInDays;
    this.clickedStageStatusVal = "";
  }
  getTotalCountDueInDays() {
    return this.dueInDaysList.reduce((total: number, item: { count: number }) => total + item.count, 0);
  }
  handleRecommandationChartClick(e: any): void {
    this.titleName = "Recommendation Count"
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
    this.tableDataList("recommandation", "", "");
    this.clickedType = "Recommendation";
    this.clickedVal = "Recommendation";
    this.clickedStageStatusVal = "";
  }
  handleSeverityChartClick(e: any): void {
    this.titleName = "Finding Severity"
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
    this.tableDataList("severity", this.severityList[e.dataPointIndex].severity, "");
    this.clickedType = "Finding severity";
    this.clickedVal = this.severityList[e.dataPointIndex].severity;
    this.clickedStageStatusVal = "";
  }
  getTotalCountSeverity() {
    return this.severityList.reduce((total: number, item: { count: number }) => total + item.count, 0);
  }
  handleStatusChartClick(e: any): void {
    console.log('Pie chart clicked:', e);
    console.log('Pie chart clicked:', e.dataPointIndex);
    this.titleName = "Status Report";
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
    this.tableDataList("status", this.statusList[e.dataPointIndex].status, "");
    this.clickedType = "Status";
    this.clickedVal = this.statusList[e.dataPointIndex].status;
    this.clickedStageStatusVal = "";
  }
  handleStatusChartClickForTotal() {
    this.totalClickFlag = true;
    this.titleName = "Status Report";
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
    this.tableDataList("status", "", "");
    this.clickedType = "Status";
    this.clickedVal = "Status";
    this.clickedStageStatusVal = "";
  }
  getTotalCount() {
    return this.statusList.reduce((total: number, item: { count: number }) => total + item.count, 0);
  }

  handleStageStatusChartClick(e: any): void {
    this.tableDataList("stageStatus", this.stageStatusList[e.dataPointIndex].status, this.clickedStageStatusVal);
    this.clickedType = "Status";
    this.clickedVal = this.stageStatusList[e.dataPointIndex].status;
  }
  getTotalCountStageStatus() {
    return this.stageStatusList.reduce((total: number, item: { count: number }) => total + item.count, 0);
  }
  handleBaChartClick(e: any): void {
    // Handle pie chart click event here
    this.titleName = "Business Area Report"
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
    this.tableDataList("ba", this.baList[e.dataPointIndex].baValue, "");
    this.clickedType = "Business Area";
    this.clickedVal = this.baList[e.dataPointIndex].baValue;
    this.clickedStageStatusVal = "";
  }
  getTotalCountBa() {
    return this.baList.reduce((total: number, item: { cnt: number }) => total + item.cnt, 0);
  }
  handleDepartmentChartClick(e: any): void {
    // Handle pie chart click event here
    console.log('Pie chart clicked:', e);
    console.log('Pie chart clicked:', e.dataPointIndex);
    this.titleName = "Department Report"
    console.log('Pie chart clicked:222', e);
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
    console.log('Pie chart clicked:22', e);
    this.tableDataList("dep", this.departmentList[e.dataPointIndex].deptCode, "");
    console.log('Pie chart clicked:2', e);
    this.clickedType = "Department";
    this.clickedVal = this.departmentList[e.dataPointIndex].deptCode;
    this.clickedStageStatusVal = "";
  }
  getTotalCountDepartment() {
    return this.departmentList.reduce((total: number, item: { count: number }) => total + item.count, 0);
  }
  handleTaskTypeChartClick(e: any): void {
    // Handle pie chart click event here
    console.log('Pie chart clicked:', e);
    console.log('Pie chart clicked:', e.dataPointIndex);
    this.titleName = "Task Type Report"
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
    this.tableDataList("tasktype", this.taskTypeList[e.dataPointIndex].taskType, "");
    this.clickedType = "Task Type";
    this.clickedVal = this.taskTypeList[e.dataPointIndex].taskType;
    this.clickedStageStatusVal = "";
  }
  getTotalCountTaskType() {
    return this.taskTypeList.reduce((total: number, item: { count: number }) => total + item.count, 0);
  }
  handleActivityReportChartClick(e: any): void {
    // Handle pie chart click event here
    console.log('Pie chart clicked:', e);
    console.log('Pie chart clicked:', e.dataPointIndex);
    this.titleName = "Activity Report"
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
    this.tableDataList("activity", this.activityReportList[e.dataPointIndex].axisValue, "");
    this.clickedType = "Activity";
    this.clickedVal = this.activityReportList[e.dataPointIndex].axisValue;
    this.clickedStageStatusVal = "";
  }
  getTotalCountActivity() {
    return this.activityReportList.reduce((total: number, item: { count: number }) => total + item.count, 0);
  }
  handleAvgTimeTotalChartClick(e: any): void {
    // Handle pie chart click event here
    console.log('Pie chart clicked:', e);
    console.log('Pie chart clicked:', e.dataPointIndex);
    this.titleName = "Avg Time Total Report"
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
    this.tableDataList("inProgress", this.inprogressVSTotalList[e.dataPointIndex].axisValue, "");
    this.clickedType = "Avg Time Total";
    this.clickedVal = this.inprogressVSTotalList[e.dataPointIndex].axisValue;
    this.clickedStageStatusVal = "";
  }

  handleAvgTimeInprogressChartClick(e: any): void {
    // Handle pie chart click event here
    console.log('Pie chart clicked:', e);
    console.log('Pie chart clicked:', e.dataPointIndex);
    this.titleName = "Task Type Report"
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
    this.tableDataList("inProgress", this.inprogressVSTotalList[e.dataPointIndex].axisValue, "");
    this.clickedType = "Task Type";
    this.clickedVal = this.inprogressVSTotalList[e.dataPointIndex].axisValue;
    this.clickedStageStatusVal = "";
  }

  handleExtensionChartClick(e: any): void {
    // Handle pie chart click event here
    console.log('Pie chart clicked:', e);
    console.log('Pie chart clicked:', e.dataPointIndex);
    this.titleName = "Extension Report"
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
    this.tableDataList("extension", this.extensionList[e.dataPointIndex].axisValue, "");
    this.clickedType = "Extension";
    this.clickedVal = this.extensionList[e.dataPointIndex].axisValue;
    this.clickedStageStatusVal = "";
  }
  getTotalCountExtension() {
    return this.extensionList.reduce((total: number, item: { count: number }) => total + item.count, 0);
  }
  handleECChartClick(e: any): void {
    // Handle pie chart click event here
    console.log('Pie chart clicked:', e);
    console.log('Pie chart clicked:', e.dataPointIndex);
    this.titleName = "EC Report"
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
    this.tableDataList("ec", this.ecList[e.dataPointIndex].axisValue, "");
    this.clickedType = "EC";
    this.clickedVal = this.ecList[e.dataPointIndex].axisValue;
    this.clickedStageStatusVal = "";
  }
  getTotalCountEc() {
    return this.ecList.reduce((total: number, item: { count: number }) => total + item.count, 0);
  }
  handleActionChartClick(e: any): void {
    // Handle pie chart click event here
    console.log('Pie chart clicked:', e);
    console.log('Pie chart clicked:', e.dataPointIndex);
    this.titleName = "Action Report"
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
    this.tableDataList("action", this.actionList[e.dataPointIndex].axisValue, "");
    this.clickedType = "Action";
    this.clickedVal = this.actionList[e.dataPointIndex].axisValue;
    this.clickedStageStatusVal = "";
  }
  getTotalCountAction() {
    return this.actionList.reduce((total: number, item: { count: number }) => total + item.count, 0);
  }
  moreActivityReport() {
    this.router.navigate(['/dashboard/MoreActivityReportComponent/', this.qmsservice.moduleName]);
  }
  whereValsForExcel: any;
  baWhereVals = "";
  tableDataList(type: any, valueOfWhere: any, stageNameForTable: any) {
    console.log(this.showReportFlagValue + "type=", type);
    let selectedQmsDept1 = "";
    if (this.selectedQmsDept.length != 0) {
      for (let j = 0; j < this.selectedQmsDept.length; j++) {
        selectedQmsDept1 += this.selectedQmsDept[j];
        selectedQmsDept1 += j == this.selectedQmsDept.length - 1 ? "" : ",";
      }
    }
    this.baWhereVals = "";
    let whereVals = '';
    if (type == "stage") {
      this.showReportFlagValue = 1;
      whereVals = " WHERE STAGE_NAME='" + valueOfWhere + "'"
    } else if (type == "status") {
      this.showReportFlagValue = 1;
      whereVals = " WHERE STATUS='" + valueOfWhere + "'"
    } else if (type == "oosType") {
      this.showReportFlagValue = 1;
      whereVals = " WHERE OOST_TYPE='" + valueOfWhere + "'"
    } else if (type == "stageStatus") {
      this.showReportFlagValue = 1;
      whereVals = " WHERE STAGE_NAME='" + stageNameForTable + "' AND STATUS='" + valueOfWhere + "'"
    } else if (type == "dep") {
      if (this.qmsservice.moduleName == "AU") {
        this.showReportFlagValue = 1;
        if (valueOfWhere != null && valueOfWhere != 'undefined') {
          whereVals = " WHERE AUDIT_DEPARTMENT='" + valueOfWhere + "'"
        } else {
          whereVals = " WHERE AUDIT_DEPARTMENT IS NULL OR AUDIT_DEPARTMENT = ''";
        }
      } else if (this.qmsservice.moduleName == "OOS") {
        this.showReportFlagValue = 1;
        console.log("valueOfWhere=", valueOfWhere);
        if (valueOfWhere) {
          whereVals = " WHERE OOS_DEPT_CODE='" + valueOfWhere + "'"
        } else {
          whereVals = " WHERE OOS_DEPT_CODE IS NULL OR OOS_DEPT_CODE = ''";
        }

      } else {
        this.showReportFlagValue = 1;
        if (valueOfWhere != null && valueOfWhere != 'undefined') {
          whereVals = " WHERE DEPT_CODE='" + valueOfWhere + "'";
        } else {
          whereVals = " WHERE DEPT_CODE IS NULL OR DEPT_CODE = ''";
        }
      }
    } else if (type == "ba") {
      this.showReportFlagValue = 1;
      whereVals = " WHERE ',' || CORE_BUSINESS_AREA_NAME || ',' LIKE '%," + valueOfWhere + ",%'"
      this.baWhereVals = " WHERE ORG_ID=?1 AND CORE_BUSINESS_AREA_NAME LIKE '%" + valueOfWhere + "%'";
    } else if (type == "tasktype") {
      if (this.qmsservice.moduleName == "AU") {
        this.showReportFlagValue = 1;
        if (valueOfWhere != null && valueOfWhere != 'undefined') {
          whereVals = "  WHERE AUDIT_TYPE='" + valueOfWhere + "'"
        } else {
          whereVals = " WHERE AUDIT_TYPE IS NULL OR AUDIT_TYPE = ''";
        }
      } else {
        this.showReportFlagValue = 1;

        if (valueOfWhere != null && valueOfWhere != 'undefined') {
          whereVals = " WHERE TASK_TYPE='" + valueOfWhere + "'";
        } else {
          whereVals = " WHERE TASK_TYPE IS NULL OR TASK_TYPE = '' OR TASK_TYPE = '-'";
        }
      }
    } else if (type == "activity") {
      this.showReportFlagValue = 1;
      whereVals = " WHERE AXIS_VALUE='" + valueOfWhere + "'"
    } else if (type == "inProgress") {
      this.showReportFlagValue = 1;
      whereVals = " WHERE STATUS = 'Closed' AND AXIS_VALUE='" + valueOfWhere + "'"
    } else if (type == "extension") {
      this.showReportFlagValue = 2;
      whereVals = " WHERE AXIS_VALUE='" + valueOfWhere + "'"
    } else if (type == "ec") {
      this.showReportFlagValue = 3;
      whereVals = " WHERE AXIS_VALUE='" + valueOfWhere + "'"
    } else if (type == "action") {
      this.showReportFlagValue = 4;
      whereVals = " WHERE AXIS_VALUE='" + valueOfWhere + "'"
    } else if (type == "finding") {
      this.showReportFlagValue = 5;
      whereVals = " WHERE STATUS='" + valueOfWhere + "'"
    } else if (type == "severity") {
      this.showReportFlagValue = 5;
      if (valueOfWhere != null && valueOfWhere != 'undefined') {
        whereVals = "  WHERE SEVERITY='" + valueOfWhere + "'"
      } else {
        whereVals = " WHERE SEVERITY IS NULL OR SEVERITY = ''";
      }
    } else if (type == "followup") {
      this.showReportFlagValue = 6;
      whereVals = " WHERE STATUS='" + valueOfWhere + "'"
    } else if (type == "recommandation") {
      this.showReportFlagValue = 7;
      whereVals = ""
    } else if (type == "dueInDays") {
      this.showReportFlagValue = 8;
      whereVals = " WHERE DUE_IN_DAYS='" + valueOfWhere + "'"
    }
    let dateRangeAt = null;
    if (this.qmsservice.moduleName === 'AU') {
      dateRangeAt = this.selectedAuDateRangeValue || null;
    } else {
      dateRangeAt = this.selectedDateRangeValue || null;
    }
    this.whereValsForExcel = "";
    this.whereValsForExcel = whereVals;
    let data = {
      groupId: this.selectedGroupValue ? this.selectedGroupValue : null,
      module: this.qmsservice.moduleName,
      dateRangeAt: dateRangeAt,
      fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
      toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
      intervals: this.selectedIntervalValue ?? null,
      stageName: this.selectedStageValue ?? null,
      status: this.selectedStatusValue ?? null,
      deptCode: selectedQmsDept1 ?? null,
      annualRefNo: this.annualRefNo ?? null,
      wherVal: whereVals
    }
    this.isProcessing = true;
    if (this.showReportFlagValue == 1) {
      if (this.qmsservice.moduleName == "AU") {
        forkJoin([
          this.appService.getAUTableReportDataList(data)]).subscribe(([stageList]) => {
            this.tableReportDataList = stageList;
            this.calculateTotalPages = this.collectionSize / this.perPage;
            this.pager.totalPages = undefined;
            this.collectionSize = this.tableReportDataList.length;
            this.totalPages = Math.ceil(this.tableReportDataList.length / this.itemsPerPage);
            this.setPage1(1, 0);
            this.isProcessing = false;
          });
        if (this.auditGridFlag == 'plan') {
          this.columnList = "Audit ID,Temporary Audit Number,Schedule Number,Annual Reference Number,Sub Group Name,Audit Type,Audit Category,Audit Classification,Audit Department,Department Name,Functional Area or Services,Audit Proposed Date,Start Date,End Date,Short Description,Status,Peer Review Completed On,Extensions,Multiple Plans,Schedule Status,Scheduled by User,Schedule Approved by User,Intimate to Plan N Days Before,Plan Created On,Plan Created From,Planned by User,Plan Approved by User,Intimate to Conduct N Days Before,Lead Auditor User,Lead Auditor Comments,Vendor Name,Vendor Status,Audit Purpose,Audit Scope,Audit References,Executive Summary,Remarks,Question and Answer Section Type,Expected to be Started On,Expected Closure On,Initiated On,Started On,Completed On,Questionnaire Sent to Vendor On,Report Sent to Vendor On,Report Sent to Vendor By,Response Received from Vendor On,Is Risk Calculation Required,Final Number Generated,Created On,Created by User,Updated On,Updated by User,Last Action On,Last Action by User,Last Action Comments,Last Action from Status,Stage Sequence,Stage Name,Plan Approval Requested On,Plan Approved On,Schedule Approval Requested On,Schedule Approved On";
        } else if (this.auditGridFlag == 'schedule') {
          this.columnList = "Schedule Number,Annual Reference Number,Sub Group Name,Audit Type,Audit Category,Audit Classification,Audit Department,Department Name,Functional Area or Services,Audit Proposed Date,Short Description,Status,Multiple Plans,Schedule Status,Scheduled by User,Schedule Approved by User,Lead Auditor User,Intimate to Plan N Days Before,Expected to be Started On,Expected Closure On,Audit Purpose,Audit Scope,Audit References,Remarks,Created On,Created by User,Updated On,Updated by User,Last Action On,Last Action by User,Last Action Comments,Last Action from Status,Stage Sequence,Stage Name,Is Risk Calculation Required,Plan Approval Requested On,Plan Approved On,Schedule Approval Requested On,Schedule Approved On";
        } else if (this.auditGridFlag == 'conduct') {
          this.columnList = "Temporary Audit Number,Au ID,Schedule Number,Annual Reference Number,Sub Group Name,Audit Type,Audit Category,Audit Classification,Audit Department,Department Name,Functional Area or Services,Audit Proposed Date,Start Date,End Date,Short Description,Status,Peer Review Completed On,Extensions,Multiple Plans,Schedule Status,Scheduled by User,Schedule Approved by User,Intimate to Plan N Days Before,Audit Purpose,Audit Scope,Audit References,Remarks,Expected to be Started On,Expected Closure On,Plan Created On,Plan Created From,Planned by User,Plan Approved by User,Intimate to Conduct N Days Before,Lead Auditor User,Lead Auditor Comments,Vendor Name,Vendor Status,Question and Answer Section Type,Initiated On,Started On,Completed On,Questionnaire Sent to Vendor On,Report Sent to Vendor On,Report Sent to Vendor By,Response Received from Vendor On,Audit Overall Outcome,Audit Conclusion,Audit Outcome Status,Is Risk Calculation Required,Final Risk Score,Final Risk Status,Final Number Generated,Created On,Created by User,Updated On,Updated by User,Last Action On,Last Action by User,Last Action Comments,Last Action from Status,Stage Sequence,Stage Name,Executive Summary,Plan Approval Requested On,Plan Approved On,Schedule Approval Requested On,Schedule Approved On";
        } else {
          this.columnList = "Temporary AU Number,AU ID,Schedule Number,Annual Reference Number,Subgroup Name,Audit Type,Audit Category,Audit Classification,Audit Proposed Date,Start Date,End Date,Short Description,Status,Peer Review Completed On,Extensions,Multiple Plans,Schedule Status,Schedule By,Schedule Approver,Intimate to Plan N Days Before,Plan Created On,Plan Created From,Plan By,Plan Approver,Intimate to Conduct N Days Before,Lead Auditor,Lead Auditor Comments,Vendor Name,Vendor Status,Audit Department,Department Name,Functional Area or Services,Audit Address,Audit Master ID,Audit Purpose,Audit Scope,Audit References,Executive Summary,Remarks,Question and Answer Section Type,Expected to Be Started On,Initiated On,Started On,Expected Closure On,Completed On,Questionnaire Sent to Vendor On,Report Sent to Vendor On,Report Sent to Vendor By,Audit Overall Outcome,Audit Outcome Status,Conclusion,Response Received from Vendor On,Is Risk Calculation Required,Final Risk Score,Final Risk Status,Final Number Generated,Initiator User,Created On,Created By User,Updated On,Updated By User,Last Action On,Last Action By User,Last Action Comments,Last Action From Status,Sequence,Axis Value,Intervals,Stage Sequence,Stage Name,Plan Approval Requested On,Plan Approved On,Schedule Approval Requested On,Schedule Approved On";
        }
      } else {
        if (this.qmsservice.moduleName == "CR") {
          this.dynamicGridName = "CR_REPORT";
          this.dynamicGridViewName = "QMS_CR_REPORT_VW";
        } else if (this.qmsservice.moduleName == "CAPA") {
          this.dynamicGridName = "CAPA_REPORT";
          this.dynamicGridViewName = "QMS_CAPA_REPORT_VW";
        } else if (this.qmsservice.moduleName == "DV") {
          this.dynamicGridName = "DV_REPORT";
          this.dynamicGridViewName = "QMS_DV_REPORT_VW";
        } else if (this.qmsservice.moduleName == "IN") {
          this.dynamicGridName = "IN_REPORT";
          this.dynamicGridViewName = "QMS_IN_REPORT_VW";
        } else if (this.qmsservice.moduleName == "CC") {
          this.dynamicGridName = "CC_REPORT";
          this.dynamicGridViewName = "QMS_CC_REPORT_VW";
        } else if (this.qmsservice.moduleName == "QI") {
          this.dynamicGridName = "QI_REPORT";
          this.dynamicGridViewName = "QMS_QI_REPORT_VW";
        } else if (this.qmsservice.moduleName == "OOS") {
          this.dynamicGridName = "OOS_REPORT";
          this.dynamicGridViewName = "QMS_OOS_REPORT_VW";
        }
        this.getcallMethod(whereVals, type);
      }
    } else if (this.showReportFlagValue == 2) {
      forkJoin([
        this.appService.getExtentionTableReportDataList(data)]).subscribe(([exList]) => {
          this.extensionTableReportDataList = exList;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.extensionTableReportDataList.length;
          this.totalPages = Math.ceil(this.extensionTableReportDataList.length / this.itemsPerPage);
          this.setPage2(1, 0);
          this.isProcessing = false;
        });

      this.columnList = `${this.qmsservice.moduleName} ID,Extension ID,Current Due Date,Extension Required Till,Justification,Status,Review Requested On,Reviewed By,Reviewer,Reviewed On,Review Comments,Approve Requested On,Approved By,Approver,Approved On,Approver Comments,Created By User,Extension Type,Action Details`;
    } else if (this.showReportFlagValue == 3) {
      forkJoin([
        this.appService.getEcTableReportDataList(data)]).subscribe(([ecList]) => {
          this.ecTableReportDataList = ecList;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.ecTableReportDataList.length;
          this.totalPages = Math.ceil(this.ecTableReportDataList.length / this.itemsPerPage);
          this.setPage3(1, 0);
          this.isProcessing = false;
        });
      this.columnList = "Due Date,Methodology,Criteria,Conclusion,Outcome,Closure Comments,Approval Requested On,Approval Comments,Approved On,Approver,QA Approval Requested On,QA Approved On,QA Approver,QA Approval Comments,Remind N Days Before Due Date,Created By User,Seq,Axis Value,Intervals,Task ID,EC ID,Triggered From EC ID,Check Reqd For,Staus,Owner Name,Start Date";


    } else if (this.showReportFlagValue == 4) {
      forkJoin([
        this.appService.getActionTableReportDataList(data)]).subscribe(([acList]) => {
          this.actionTableReportDataList = acList;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.actionTableReportDataList.length;
          this.totalPages = Math.ceil(this.actionTableReportDataList.length / this.itemsPerPage);
          this.setPage4(1, 0);
          this.isProcessing = false;
        });
      this.columnList = this.qmsservice.moduleName + " ID,SL NO,Action ID,Action Name,Started On,Status,Target Date,Action At,Core Business Area,Assigned To,Assigned To Department,Comments,Action Performed,Review Requested On,Reviewer,Review Status,Review Comments,Review Completed On,Approval Requested On,Approver,Approval Status,Approval Comments,Approval Completed On,Defer Reviewer,Defer Approver,Created On,Created By User,Seq,Axis Value,Intervals";
    } else if (this.showReportFlagValue == 5) {
      forkJoin([
        this.appService.getFindingTableVal(data)]).subscribe(([fiList]) => {
          this.findingTableReportDataList = fiList;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.findingTableReportDataList.length;
          this.totalPages = Math.ceil(this.findingTableReportDataList.length / this.itemsPerPage);
          this.setPage5(1, 0);
          this.isProcessing = false;
        });
      this.columnList = "Audit ID,Finding ID,Seq,Finding,Status,Annual Ref No,Sub Group Name,Response Due Date,Assigned To User,Assigned To Department,Finding Short Description,Reference,Deliverables,Severity,Auditor Comments,Root Cause Analysis,Immediate Correction,Corrective Action,Preventive Action,Expected CA Closure Date,Expected PA Closure Date,Expected Closure Date,Isolated CAPA Required,CAPA Details,Response Reviewed By User,Response Review Status,Response Review Completed On,Response Reviewer Comments,Response Verification Requested On,Response Verified On,Response Verification Comments,Implementation Reviewed By User,Implementation Review Status,Implementation Review Completed On,Implementation Reviewer Comments,Implementation Verification Requested On,Implementation Verified On,Implementation Verification Comments,Is Implementation Accepted,Closure Comments,Comments,Completed On,Final Risk Status,Final Risk Score,Response Review Requested On,Implementation Review Requested On,Created On,Created By,Updated On,Updated By";
    } else if (this.showReportFlagValue == 6) {
      forkJoin([
        this.appService.getFollowupTableReportDataList(data)]).subscribe(([acList]) => {
          this.followupTableReportDataList = acList;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.followupTableReportDataList.length;
          this.totalPages = Math.ceil(this.followupTableReportDataList.length / this.itemsPerPage);
          this.setPage6(1, 0);
          this.isProcessing = false;
        });

      this.columnList = "Audit Id,Finding Id,Followup Id,Sub Group Name,Annual Ref No,Status,Audit Department,Due Date,Assigned To User,Assigned To Department,Assigned To User Details,Responses Pending,Completed On,Comments,Created On,Created By,Updated On,Updated By";
    } else if (this.showReportFlagValue == 7) {
      forkJoin([
        this.appService.getRecommandationTableReportDataList(data)]).subscribe(([rcList]) => {
          this.recommendationTableReportDataList = rcList;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.recommendationTableReportDataList.length;
          this.totalPages = Math.ceil(this.recommendationTableReportDataList.length / this.itemsPerPage);
          this.setPage7(1, 0);
          this.isProcessing = false;
        });
      this.columnList = "Recommendation Id,Sub Group Name,Annual Ref No,Description,Reference Details,Auditee Comments,Created By,Created On,Updated By,Updated On";
    } else if (this.showReportFlagValue == 8) {
      forkJoin([
        this.appService.getDueInDaysReportValTableVal(data)]).subscribe(([DueList]) => {
          this.dueInDaysTableReportDataList = DueList;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.dueInDaysTableReportDataList.length;
          this.totalPages = Math.ceil(this.dueInDaysTableReportDataList.length / this.itemsPerPage);
          this.setPage8(1, 0);
          this.isProcessing = false;
        });
      if (this.qmsservice.moduleName == "AU") {
        this.columnList = `${this.qmsservice.moduleName} ID,Due In Days,Module,Expected Closure On,Expected To Be Started On,Short Description,${this.qmsservice.moduleName} Type,Initiator Fullname,Owner,Qa Acceptor Name,Last Action From Status,Last Action On,Status,Stop Reminders,Stage Name,Created On,Effectiveness Check Reqd,Final No Generated,Final Risk Status,Investigation Required,Investigator,Is Q and a Reqd,Completed On,Started On`;
      } else {
        this.columnList = `${this.qmsservice.moduleName} ID,Due In Days,Module,Expected Closure On,Expected To Be Started On,Short Description,${this.qmsservice.moduleName} Type,Requested At,Business Area,Initiator Fullname,Owner,Qa Acceptor Name,Last Action From Status,Last Action On,Status,Stop Reminders,Stage Name,Created On,Effectiveness Check Reqd,Final No Generated,Final Risk Status,Investigation Required,Investigator,Is Q and a Reqd,Completed On,Started On`;
      }
    } else {
      console.log(this.showReportFlagValue + "777type=", type);
    }
  }


  tableDataListForAll(type: any, valueOfWhere: any, stageNameForTable: any) {
    console.log(this.showReportFlagValue + "type=", type);
    let selectedQmsDept1 = "";
    if (this.selectedQmsDept.length != 0) {
      for (let j = 0; j < this.selectedQmsDept.length; j++) {
        selectedQmsDept1 += this.selectedQmsDept[j];
        selectedQmsDept1 += j == this.selectedQmsDept.length - 1 ? "" : ",";
      }
    }
    let whereVals = "";
    this.baWhereVals = "";
    if (type == "stage") {
      this.showReportFlagValue = 1;
    } else if (type == "status") {
      this.showReportFlagValue = 1;
    } else if (type == "stageStatus") {
      this.showReportFlagValue = 1;
    } else if (type == "dep") {
      this.showReportFlagValue = 1;
    } else if (type == "ba") {
      this.showReportFlagValue = 1;
      this.baWhereVals = " WHERE ORG_ID=?1 ";
    } else if (type == "tasktype") {
      this.showReportFlagValue = 1;
    } else if (type == "activity") {
      this.showReportFlagValue = 1;
    } else if (type == "inProgress") {
      this.showReportFlagValue = "";
    } else if (type == "extension") {
      this.showReportFlagValue = 2;
    } else if (type == "ec") {
      this.showReportFlagValue = 3;
    } else if (type == "action") {
      this.showReportFlagValue = 4;
    } else if (type == "finding") {
      this.showReportFlagValue = 5;
    } else if (type == "severity") {
      this.showReportFlagValue = 5;
    } else if (type == "followup") {
      this.showReportFlagValue = 6;
    } else if (type == "recommandation") {
      this.showReportFlagValue = 7;
    } else if (type == "dueInDays") {
      this.showReportFlagValue = 8;
    }
    let dateRangeAt = null;
    if (this.qmsservice.moduleName === 'AU') {
      dateRangeAt = this.selectedAuDateRangeValue || null;
    } else {
      dateRangeAt = this.selectedDateRangeValue || null;
    }
    this.whereValsForExcel = whereVals;
    let data = {
      groupId: this.selectedGroupValue ? this.selectedGroupValue : null,
      module: this.qmsservice.moduleName,
      dateRangeAt: dateRangeAt,
      fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
      toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
      intervals: this.selectedIntervalValue ?? null,
      stageName: this.selectedStageValue ?? null,
      status: this.selectedStatusValue ?? null,
      deptCode: selectedQmsDept1 ?? null,
      annualRefNo: this.annualRefNo ?? null,
      wherVal: whereVals
    }
    this.isProcessing = true;
    if (this.showReportFlagValue == 1) {
      if (this.qmsservice.moduleName == "AU") {
        forkJoin([
          this.appService.getAUTableReportDataList(data)]).subscribe(([stageList]) => {
            this.tableReportDataList = stageList;
            this.calculateTotalPages = this.collectionSize / this.perPage;
            this.pager.totalPages = undefined;
            this.collectionSize = this.tableReportDataList.length;
            this.totalPages = Math.ceil(this.tableReportDataList.length / this.itemsPerPage);
            this.setPage1(1, 0);
            this.isProcessing = false;
          });
        if (this.auditGridFlag == 'plan') {
          this.columnList = "Audit ID,Temporary Audit Number,Schedule Number,Annual Reference Number,Sub Group Name,Audit Type,Audit Category,Audit Classification,Audit Department,Department Name,Functional Area or Services,Audit Proposed Date,Start Date,End Date,Short Description,Status,Peer Review Completed On,Extensions,Multiple Plans,Schedule Status,Scheduled by User,Schedule Approved by User,Intimate to Plan N Days Before,Plan Created On,Plan Created From,Planned by User,Plan Approved by User,Intimate to Conduct N Days Before,Lead Auditor User,Lead Auditor Comments,Vendor Name,Vendor Status,Audit Purpose,Audit Scope,Audit References,Executive Summary,Plan Approval Requested On,Plan Approved On,Plan Approver Comments,Schedule Approver Comments,Schedule Approval Requested On,Schedule Approved On,Remarks,Question and Answer Section Type,Expected to be Started On,Expected Closure On,Initiated On,Started On,Completed On,Questionnaire Sent to Vendor On,Report Sent to Vendor On,Report Sent to Vendor By,Response Received from Vendor On,Is Risk Calculation Required,Final Number Generated,Created On,Created by User,Updated On,Updated by User,Last Action On,Last Action by User,Last Action Comments,Last Action from Status,Stage Sequence,Stage Name";
        } else if (this.auditGridFlag == 'schedule') {
          this.columnList = "Schedule Number,Annual Reference Number,Sub Group Name,Audit Type,Audit Category,Audit Classification,Audit Department,Department Name,Functional Area or Services,Audit Proposed Date,Short Description,Status,Multiple Plans,Schedule Status,Scheduled by User,Schedule Approved by User,Plan Approver Comments,Schedule Approver Comments,Lead Auditor User,Intimate to Plan N Days Before,Expected to be Started On,Expected Closure On,Audit Purpose,Audit Scope,Audit References,Remarks,Created On,Created by User,Updated On,Updated by User,Last Action On,Last Action by User,Last Action Comments,Last Action from Status,Stage Sequence,Stage Name,Is Risk Calculation Required,Schedule Approval Requested On,Schedule Approved On";
        } else if (this.auditGridFlag == 'conduct') {
          this.columnList = "Temporary Audit Number,Au ID,Schedule Number,Annual Reference Number,Sub Group Name,Audit Type,Audit Category,Audit Classification,Audit Department,Department Name,Functional Area or Services,Audit Proposed Date,Start Date,End Date,Short Description,Status,Peer Review Completed On,Extensions,Multiple Plans,Schedule Status,Scheduled by User,Schedule Approved by User,Plan Approver Comments,Schedule Approver Comments,Intimate to Plan N Days Before,Audit Purpose,Audit Scope,Audit References,Remarks,Expected to be Started On,Expected Closure On,Plan Created On,Plan Created From,Planned by User,Plan Approved by User,Intimate to Conduct N Days Before,Lead Auditor User,Lead Auditor Comments,Vendor Name,Vendor Status,Question and Answer Section Type,Initiated On,Started On,Completed On,Questionnaire Sent to Vendor On,Report Sent to Vendor On,Report Sent to Vendor By,Response Received from Vendor On,Audit Overall Outcome,Audit Conclusion,Audit Outcome Status,Is Risk Calculation Required,Final Risk Score,Final Risk Status,Final Number Generated,Created On,Created by User,Updated On,Updated by User,Last Action On,Last Action by User,Last Action Comments,Last Action from Status,Stage Sequence,Stage Name,Plan Approval Requested On,Plan Approved On,Schedule Approval Requested On,Schedule Approved On";
        } else {
          this.columnList = "Temporary AU Number,AU ID,Schedule Number,Annual Reference Number,Subgroup Name,Audit Type,Audit Category,Audit Classification,Audit Proposed Date,Start Date,End Date,Short Description,Status,Peer Review Completed On,Extensions,Multiple Plans,Schedule Status,Schedule By,Schedule Approver,Intimate to Plan N Days Before,Plan Created On,Plan Created From,Plan By,Plan Approver,Intimate to Conduct N Days Before,Lead Auditor,Lead Auditor Comments,Vendor Name,Vendor Status,Audit Department,Department Name,Functional Area or Services,Audit Address,Audit Master ID,Audit Purpose,Audit Scope,Audit References,Executive Summary,Remarks,Question and Answer Section Type,Expected to Be Started On,Initiated On,Started On,Expected Closure On,Completed On,Questionnaire Sent to Vendor On,Report Sent to Vendor On,Report Sent to Vendor By,Audit Overall Outcome,Audit Outcome Status,Conclusion,Response Received from Vendor On,Is Risk Calculation Required,Final Risk Score,Final Risk Status,Final Number Generated,Initiator User,Created On,Created By User,Updated On,Updated By User,Last Action On,Last Action By User,Last Action Comments,Last Action From Status,Sequence,Axis Value,Intervals,Stage Sequence,Stage Name,Plan Approval Requested On,Plan Approved On,Schedule Approval Requested On,Schedule Approved On";
        }
      } else {
        if (this.qmsservice.moduleName == "CR") {
          this.dynamicGridName = "CR_REPORT";
          this.dynamicGridViewName = "QMS_CR_REPORT_VW";
        } else if (this.qmsservice.moduleName == "CAPA") {
          this.dynamicGridName = "CAPA_REPORT";
          this.dynamicGridViewName = "QMS_CAPA_REPORT_VW";
        } else if (this.qmsservice.moduleName == "DV") {
          this.dynamicGridName = "DV_REPORT";
          this.dynamicGridViewName = "QMS_DV_REPORT_VW";
        } else if (this.qmsservice.moduleName == "IN") {
          this.dynamicGridName = "IN_REPORT";
          this.dynamicGridViewName = "QMS_IN_REPORT_VW";
        } else if (this.qmsservice.moduleName == "CC") {
          this.dynamicGridName = "CC_REPORT";
          this.dynamicGridViewName = "QMS_CC_REPORT_VW";
        } else if (this.qmsservice.moduleName == "QI") {
          this.dynamicGridName = "QI_REPORT";
          this.dynamicGridViewName = "QMS_QI_REPORT_VW";
        } else if (this.qmsservice.moduleName == "OOS") {
          this.dynamicGridName = "OOS_REPORT";
          this.dynamicGridViewName = "QMS_OOS_REPORT_VW";
        }
        this.getcallMethod(whereVals, type);
      }
    } else if (this.showReportFlagValue == 2) {
      forkJoin([
        this.appService.getExtentionTableReportDataList(data)]).subscribe(([exList]) => {
          this.extensionTableReportDataList = exList;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.extensionTableReportDataList.length;
          this.totalPages = Math.ceil(this.extensionTableReportDataList.length / this.itemsPerPage);
          this.setPage2(1, 0);
          this.isProcessing = false;
        });
      this.columnList = `${this.qmsservice.moduleName} ID,Extension ID,Current Due Date,Extension Required Till,Justification,Status,Review Requested On,Reviewer,Reviewed On,Review Comments,Approve Requested On,Approved By,Approver,Approved On,Approver Comments,Created By User,Extension Type,Action Details`;
    } else if (this.showReportFlagValue == 3) {
      forkJoin([
        this.appService.getEcTableReportDataList(data)]).subscribe(([ecList]) => {
          this.ecTableReportDataList = ecList;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.ecTableReportDataList.length;
          this.totalPages = Math.ceil(this.ecTableReportDataList.length / this.itemsPerPage);
          this.setPage3(1, 0);
          this.isProcessing = false;
        });
      this.columnList = "Due Date,Methodology,Criteria,Conclusion,Outcome,Closure Comments,Approval Requested On,Approval Comments,Approved On,Approver,QA Approval Requested On,QA Approved On,QA Approver,QA Approval Comments,Remind N Days Before Due Date,Created By User,Seq,Axis Value,Intervals,Task ID,EC ID,Triggered From EC ID,Check Reqd For,Staus,Owner Name,Start Date";
    } else if (this.showReportFlagValue == 4) {
      forkJoin([
        this.appService.getActionTableReportDataList(data)]).subscribe(([acList]) => {
          this.actionTableReportDataList = acList;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.actionTableReportDataList.length;
          this.totalPages = Math.ceil(this.actionTableReportDataList.length / this.itemsPerPage);
          this.setPage4(1, 0);
          this.isProcessing = false;
        });
      this.columnList = this.qmsservice.moduleName + " ID,Started On,Action ID,SL NO,Action Name,Status,Target Date,Action At,Core Business Area,Assigned To,Assigned To Department,Comments,Action Performed,Review Requested On,Reviewer,Review Status,Review Comments,Review Completed On,Approval Requested On,Approver,Approval Status,Approval Comments,Approval Completed On,Defer Reviewer,Defer Approver,Created On,Created By User,Seq,Axis Value,Intervals";
    } else if (this.showReportFlagValue == 5) {
      forkJoin([
        this.appService.getFindingTableVal(data)]).subscribe(([fiList]) => {
          this.findingTableReportDataList = fiList;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.findingTableReportDataList.length;
          this.totalPages = Math.ceil(this.findingTableReportDataList.length / this.itemsPerPage);
          this.setPage5(1, 0);
          this.isProcessing = false;
        });
      this.columnList = "Audit No,Finding ID,Sequence Number,Finding,Status,Annual Reference Number,Sub-GroupName,Response Due Date,Assigned To User Name,Assigned To Department,Finding Short Description,Reference,Deliverables,Severity,Auditor Comments,Root Cause Analysis,Immediate Correction,Corrective Action,Preventive Action,Expected Corrective Action Closure Date,Expected Preventive Action Closure Date,Expected Closure Date,Isolated CAPA Required,CAPA Details,Response Reviewed By,Response Review Status,Response Review Completed On,Response Reviewer Comments,Response Verification Requested On,Response Verified On,Response Verification Comments,Implementation Reviewed By,Implementation Review Status,Implementation Review Completed On,Implementation Reviewer Comments,Implementation Verification Requested On,Implementation Verified On,Implementation Verification Comments,Is Implementation Accepted,Closure Comments,Comments,Completed On,Final Risk Status,Final Risk Score,Created On,Created By,Updated On,Updated By";
    } else if (this.showReportFlagValue == 6) {
      forkJoin([
        this.appService.getFollowupTableReportDataList(data)]).subscribe(([acList]) => {
          this.followupTableReportDataList = acList;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.followupTableReportDataList.length;
          this.totalPages = Math.ceil(this.followupTableReportDataList.length / this.itemsPerPage);
          this.setPage6(1, 0);
          this.isProcessing = false;
        });
      this.columnList = "Intr Seq,Axis Value,Intervals,Group Id,Sub Group Name,Annual Ref No,Org Id,Au No,Followup Id,Seq,Finding Id,Assigned To User,Assigned To Department,Assigned To User Details,Responses Pending,Due Date,Completed On,Comments,Status,Created On,Created By,Updated On,Updated By";
    } else if (this.showReportFlagValue == 7) {
      forkJoin([
        this.appService.getRecommandationTableReportDataList(data)]).subscribe(([rcList]) => {
          this.recommendationTableReportDataList = rcList;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.recommendationTableReportDataList.length;
          this.totalPages = Math.ceil(this.recommendationTableReportDataList.length / this.itemsPerPage);
          this.setPage7(1, 0);
          this.isProcessing = false;
        });
      this.columnList = "Intr Seq,Axis Value,Intervals,Group Id,Sub Group Name,Annual Ref No,Org Id,Recommendation Id,Au No,Seq,Description,Reference Details,Auditee Comments,Created On,Created By,Updated On,Updated By";
    } else if (this.showReportFlagValue == 8) {
      forkJoin([
        this.appService.getDueInDaysReportValTableVal(data)]).subscribe(([DueList]) => {
          this.dueInDaysTableReportDataList = DueList;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.dueInDaysTableReportDataList.length;
          this.totalPages = Math.ceil(this.dueInDaysTableReportDataList.length / this.itemsPerPage);
          this.setPage8(1, 0);
          this.isProcessing = false;
        });
      if (this.qmsservice.moduleName == "AU") {
        this.columnList = `${this.qmsservice.moduleName} ID,Due In Days,Module,Expected Closure On,Expected To Be Started On,Short Description,${this.qmsservice.moduleName} Type,Initiator Fullname,Owner,Qa Acceptor Name,Last Action From Status,Last Action On,Status,Stop Reminders,Stage Name,Created On,Effectiveness Check Reqd,Final No Generated,Final Risk Status,Investigation Required,Investigator,Is Q and a Reqd,Completed On,Started On`;
      } else {
        this.columnList = `${this.qmsservice.moduleName} ID,Due In Days,Module,Expected Closure On,Expected To Be Started On,Short Description,${this.qmsservice.moduleName} Type,Requested At,Business Area,Initiator Fullname,Owner,Qa Acceptor Name,Last Action From Status,Last Action On,Status,Stop Reminders,Stage Name,Created On,Effectiveness Check Reqd,Final No Generated,Final Risk Status,Investigation Required,Investigator,Is Q and a Reqd,Completed On,Started On`;
      }
    } else {
      console.log("dfdsfsf")
    }
  }
  htmlContent: any;
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(data: any, column: string, val: any, view: string) {
    this.isProcessing = true;
    const formattedColumn = this.formatColumnName(column);
    this.htmlContent = val;
    this.editorComponent.openEditor(this.htmlContent, formattedColumn);
    this.isProcessing = false;
  }
  formatColumnName(column: string): string {
    return column
      .toLowerCase()
      .split('_')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  getClobData1(data: any, column: any, val: any, view: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: data.primIdentifier,
      tableView: view,
      columnName: column,
    }
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        this.htmlContent = val;
        this.editorComponent.openEditor(this.htmlContent, column);
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    })
    this.isProcessing = false;
  }

  setPage1(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.tableReportDataList.length, page, this.perPage, targetpage);
    if (this.tableReportDataList.length > 0) {
      this.pagedItems = this.tableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }
  paginationCall1(value: number) {
    this.perPage = value;
    this.setPage1(this.pager.currentPage, 0);
  }
  setPage2(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.extensionTableReportDataList.length, page, this.perPage, targetpage);
    if (this.extensionTableReportDataList.length > 0) {
      this.pagedItems1 = this.extensionTableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }
  paginationCall2(value: number) {
    this.perPage = value;
    this.setPage2(this.pager.currentPage, 0);
  }
  setPage3(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.ecTableReportDataList.length, page, this.perPage, targetpage);
    if (this.ecTableReportDataList.length > 0) {
      this.pagedItems2 = this.ecTableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }
  paginationCall3(value: number) {
    this.perPage = value;
    this.setPage3(this.pager.currentPage, 0);
  }
  setPage4(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.actionTableReportDataList.length, page, this.perPage, targetpage);
    if (this.actionTableReportDataList.length > 0) {
      this.pagedItems3 = this.actionTableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }
  paginationCall4(value: number) {
    this.perPage = value;
    this.setPage4(this.pager.currentPage, 0);
  }
  setPage5(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.findingTableReportDataList.length, page, this.perPage, targetpage);
    if (this.findingTableReportDataList.length > 0) {
      this.pagedItems5 = this.findingTableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }
  paginationCall5(value: number) {
    this.perPage = value;
    this.setPage5(this.pager.currentPage, 0);
  }
  setPage6(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.followupTableReportDataList.length, page, this.perPage, targetpage);
    if (this.followupTableReportDataList.length > 0) {
      this.pagedItems6 = this.followupTableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }

  paginationCall6(value: number) {
    this.perPage = value;
    this.setPage6(this.pager.currentPage, 0);
  }
  setPage7(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.recommendationTableReportDataList.length, page, this.perPage, targetpage);
    if (this.recommendationTableReportDataList.length > 0) {
      this.pagedItems7 = this.recommendationTableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }

  paginationCall7(value: number) {
    this.perPage = value;
    this.setPage7(this.pager.currentPage, 0);
  }

  setPage8(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.dueInDaysTableReportDataList.length, page, this.perPage, targetpage);
    if (this.dueInDaysTableReportDataList.length > 0) {
      this.pagedItems8 = this.dueInDaysTableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }

  paginationCall8(value: number) {
    this.perPage = value;
    this.setPage8(this.pager.currentPage, 0);
  }

  handleDropDownValidation(fieldId: string, selectedItems: [] | string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isMultiSelectValidation = (fieldId === 'pdf-select-all');
    const shouldBeRed = isMultiSelectValidation ? !selectedItems.length : !selectedItems;
    if (field) {
      field.style.color = shouldBeRed ? 'red' : '#005c8a';
    }
  }

  applyFilter(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.tableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.tableReportDataList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');
            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }
        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });

    }

  }
  applyFilter1(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems1 = this.extensionTableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems1 = this.extensionTableReportDataList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');

            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }

        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }

  applyFilter2(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems2 = this.ecTableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems2 = this.ecTableReportDataList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');

            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }

        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }
  applyFilter3(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems3 = this.actionTableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems3 = this.actionTableReportDataList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');

            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }

        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }

  applyFilter5(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems5 = this.findingTableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems5 = this.findingTableReportDataList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');

            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }

        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }
  applyFilter6(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems6 = this.followupTableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems6 = this.followupTableReportDataList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');

            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }

        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }
  applyFilter7(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems7 = this.recommendationTableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems7 = this.recommendationTableReportDataList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');

            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }

        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }
  applyFilter8(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems8 = this.dueInDaysTableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems8 = this.dueInDaysTableReportDataList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');

            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }

        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }
  onReportFooterSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportFooterFieldValidation != undefined) {
        this.reportFooterFieldValidation.style.color = '#005c8a';
      }
    }
  }

  ngOnChangesReportFooter() {
    this.isProcessing = true;
    this.appService.getCodeListsByGroup("REPORT_FOOTER").subscribe({
      next:
        (data: any) => {
          this.reportFooterDropdown1 = data;

          this.selectBoxForFooter();
          if (this.reportFooterDropdown.length > 0) {
            this.selectedReportFooter = this.reportFooterDropdown[0].displayExp;
          }

          this.isProcessing = false;
        },
      error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }

  selectBoxForFooter() {
    this.reportFooterDropdown = [];
    for (const vals of this.reportFooterDropdown1) {
      if (vals.moduleList == "Common" || vals.moduleList.includes(this.qmsservice.moduleName)) {
        this.reportFooterDropdown.push({
          valueExp: vals.codelistName,
          displayExp: vals.codelistName
        });
      }
    }
  }

  popupDataTitle: any = {};
  cancelReportPopup() {
    this.visibleExcelPdfPopup.close();
    this.manuallyPicked = false;
    this.selectedColumns = "";

  }
  selectedColumns: any;
  columnList: any;
  dropDownForPdfColumn: any;
  isForExcel: boolean = false;
  @ViewChild('excelPdfPopup', { static: true }) excelPdfPopup: TemplateRef<any>;
  excelPdfPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    disableClose: true,
    hasBackdrop: true,
    position: { top: '10px' },
  }
  visibleExcelPdfPopup: MatDialogRef<TemplateRef<any>>;
  reportObj: any = {};
  isSaveReport: boolean = false;

  pdfDetailSearchText: string = '';
  templateid: number;
  reportTemplateFieldValidation: any;
  reportLogoFieldValidation: any;
  onReportLogoValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.templateid = item;
      if (this.reportLogoFieldValidation != undefined) {
        this.reportLogoFieldValidation.style.color = '#005c8a';
      }

    }
  }
  reportName: any;
  onlyDateColumn: any;
  generateReport(value: any) {
    let invisibleList = "";
    if (this.manuallyPicked && !this.selectedColumns.length) {
      this.showSnackBar('Please select the Columns', 'E');
    } else if (value == 'Pdf' && this.manuallyPicked && this.selectedColumns.length > 12) {
      alert('Selected columns exceeded the limit. Limit 12, Selected ' + this.selectedColumns.length);
    } else {
      this.appService.isProcessingRep = true;

      let tname = "";
      let colList = "";
      let fieldList = "";
      this.onlyDateColumn = "";
      if (this.showReportFlagValue == 1) {
        if (this.qmsservice.moduleName == "AU" && this.auditGridFlag == 'plan') {
          tname = "QMS_AU_TASKS_INTERVALS_REP_VW";
          colList = "AU_ID,TEMP_AU_NO,SCHEDULE_NO,ANNUAL_REF_NO,SUB_GROUP_NAME,AUDIT_TYPE,AUDIT_CATEGORY,AUDIT_CLASSIFICATION,AUDIT_DEPARTMENT,DEPT_NAME,FUNCTIONAL_AREA_OR_SERVICES,AUDIT_PROPOSED_DATE,START_DATE,END_DATE,SHORT_DESCRIPTION,STATUS,PEER_REVIEW_COMPLETED_ON,EXTENSIONS,MULTIPLE_PLANS,SCHEDULE_STATUS,SCHEDULED_BY_USER,SCHEDULE_APPROVED_BY_USER,INTIMATE_TO_PLAN_N_DAYS_BEFORE,PLAN_CREATED_ON,PLAN_CREATED_FROM,PLANNED_BY_USER,PLAN_APPROVED_BY_USER,INTIMATE_TO_CONDUCT_N_DAYS_BEFORE,LEAD_AUDITOR_USER,LEAD_AUDITOR_COMMENTS,VENDOR_NAME,VENDOR_STATUS,AUDIT_PURPOSE,AUDIT_SCOPE,AUDIT_REFERENCES,EXECUTIVE_SUMMARY,PLAN_APPROVAL_REQUESTED_ON,PLAN_APPROVED_ON,SCHEDULE_APPROVAL_REQUESTED_ON,SCHEDULE_APPROVED_ON,REMARKS,QUESTION_AND_ANSWER_SECTION_TYPE,EXPECTED_TO_BE_STARTED_ON,EXPCETED_CLOSURE_ON,INITIATED_ON,STARTED_ON,COMPLETED_ON,QUESTIONNAIRE_SENT_TO_VENDOR_ON,REPORT_SENT_TO_VENDOR_ON,REPORT_SENT_TO_VENDOR_BY,RESPONSE_RECEIVED_FROM_VENDOR_ON,IS_RISK_CALCULATION_REQD,FINAL_NO_GENERATED,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER,LAST_ACTION_ON,LAST_ACTION_BY_USER,LAST_ACTION_COMMENTS,LAST_ACTION_FROM_STATUS,STAGE_SEQ,STAGE_NAME";
          fieldList = "Audit ID,Temporary Audit Number,Schedule Number,Annual Reference Number,Sub Group Name,Audit Type,Audit Category,Audit Classification,Audit Department,Department Name,Functional Area or Services,Audit Proposed Date,Start Date,End Date,Short Description,Status,Peer Review Completed On,Extensions,Multiple Plans,Schedule Status,Scheduled by User,Schedule Approved by User,Intimate to Plan N Days Before,Plan Created On,Plan Created From,Planned by User,Plan Approved by User,Intimate to Conduct N Days Before,Lead Auditor User,Lead Auditor Comments,Vendor Name,Vendor Status,Audit Purpose,Audit Scope,Audit References,Executive Summary,Plan Approval Requested On,Plan Approved On,Schedule Approval Requested On,Schedule Approved On,Remarks,Question and Answer Section Type,Expected to be Started On,Expected Closure On,Initiated On,Started On,Completed On,Questionnaire Sent to Vendor On,Report Sent to Vendor On,Report Sent to Vendor By,Response Received from Vendor On,Is Risk Calculation Required,Final Number Generated,Created On,Created by User,Updated On,Updated by User,Last Action On,Last Action by User,Last Action Comments,Last Action from Status,Stage Sequence,Stage Name";
        } else if (this.qmsservice.moduleName == "AU" && this.auditGridFlag == 'schedule') {
          tname = "QMS_AU_TASKS_INTERVALS_REP_VW";
          colList = "SCHEDULE_NO,ANNUAL_REF_NO,SUB_GROUP_NAME,AUDIT_TYPE,AUDIT_CATEGORY,AUDIT_CLASSIFICATION,AUDIT_DEPARTMENT,DEPT_NAME,FUNCTIONAL_AREA_OR_SERVICES,AUDIT_PROPOSED_DATE,SHORT_DESCRIPTION,STATUS,PEER_REVIEW_COMPLETED_ON,EXTENSIONS,MULTIPLE_PLANS,SCHEDULE_STATUS,SCHEDULED_BY_USER,SCHEDULE_APPROVED_BY_USER,LEAD_AUDITOR_USER,INTIMATE_TO_PLAN_N_DAYS_BEFORE,EXPECTED_TO_BE_STARTED_ON,EXPCETED_CLOSURE_ON,AUDIT_PURPOSE,AUDIT_SCOPE,AUDIT_REFERENCES,EXECUTIVE_SUMMARY,PLAN_APPROVAL_REQUESTED_ON,PLAN_APPROVED_ON,SCHEDULE_APPROVAL_REQUESTED_ON,SCHEDULE_APPROVED_ON,REMARKS,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER,LAST_ACTION_ON,LAST_ACTION_BY_USER,LAST_ACTION_COMMENTS,LAST_ACTION_FROM_STATUS,STAGE_SEQ,STAGE_NAME,IS_RISK_CALCULATION_REQD";
          fieldList = "Schedule Number,Annual Reference Number,Sub Group Name,Audit Type,Audit Category,Audit Classification,Audit Department,Department Name,Functional Area or Services,Audit Proposed Date,Short Description,Status,Peer Review Completed On,Extensions,Multiple Plans,Schedule Status,Scheduled by User,Schedule Approved by User,Lead Auditor User,Intimate to Plan N Days Before,Expected to be Started On,Expected Closure On,Audit Purpose,Audit Scope,Audit References,Executive Summary,Plan Approval Requested On,Plan Approved On,Schedule Approval Requested On,Schedule Approved On,Remarks,Created On,Created by User,Updated On,Updated by User,Last Action On,Last Action by User,Last Action Comments,Last Action from Status,Stage Sequence,Stage Name,Is Risk Calculation Required";
        } else if (this.qmsservice.moduleName == "AU" && this.auditGridFlag == 'conduct') {
          tname = "QMS_AU_TASKS_INTERVALS_REP_VW";
          colList = "TEMP_AU_NO,AU_ID,SCHEDULE_NO,ANNUAL_REF_NO,SUB_GROUP_NAME,AUDIT_TYPE,AUDIT_CATEGORY,AUDIT_CLASSIFICATION,AUDIT_DEPARTMENT,DEPT_NAME,FUNCTIONAL_AREA_OR_SERVICES,AUDIT_PROPOSED_DATE,START_DATE,END_DATE,SHORT_DESCRIPTION,PEER_REVIEW_COMPLETED_ON,STATUS,EXTENSIONS,MULTIPLE_PLANS,SCHEDULE_STATUS,SCHEDULED_BY_USER,SCHEDULE_APPROVED_BY_USER,INTIMATE_TO_PLAN_N_DAYS_BEFORE,AUDIT_PURPOSE,AUDIT_SCOPE,AUDIT_REFERENCES,EXECUTIVE_SUMMARY,PLAN_APPROVAL_REQUESTED_ON,PLAN_APPROVED_ON,SCHEDULE_APPROVAL_REQUESTED_ON,SCHEDULE_APPROVED_ON,REMARKS,EXPECTED_TO_BE_STARTED_ON,EXPCETED_CLOSURE_ON,PLAN_CREATED_ON,PLAN_CREATED_FROM,PLANNED_BY_USER,PLAN_APPROVED_BY_USER,INTIMATE_TO_CONDUCT_N_DAYS_BEFORE,LEAD_AUDITOR_USER,LEAD_AUDITOR_COMMENTS,VENDOR_NAME,VENDOR_STATUS,QUESTION_AND_ANSWER_SECTION_TYPE,INITIATED_ON,STARTED_ON,COMPLETED_ON,QUESTIONNAIRE_SENT_TO_VENDOR_ON,REPORT_SENT_TO_VENDOR_ON,REPORT_SENT_TO_VENDOR_BY,RESPONSE_RECEIVED_FROM_VENDOR_ON,AUDIT_OVERALL_OUTCOME,CONCLUSION,EXECUTIVE_SUMMARY,AUDIT_OUTCOME_STATUS,IS_RISK_CALCULATION_REQD,FINAL_RISK_SCORE,FINAL_RISK_STATUS,FINAL_NO_GENERATED,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER,LAST_ACTION_ON,LAST_ACTION_BY_USER,LAST_ACTION_COMMENTS,LAST_ACTION_FROM_STATUS,STAGE_SEQ,STAGE_NAME";
          fieldList = "Temporary Audit Number,Au ID,Schedule Number,Annual Reference Number,Sub Group Name,Audit Type,Audit Category,Audit Classification,Audit Department,Department Name,Functional Area or Services,Audit Proposed Date,Start Date,End Date,Short Description,Peer Review Completed On,Status,Extensions,Multiple Plans,Schedule Status,Scheduled by User,Schedule Approved by User,Intimate to Plan N Days Before,Audit Purpose,Audit Scope,Audit References,Executive Summary,Plan Approval Requested On,Plan Approved On,Schedule Approval Requested On,Schedule Approved On,Remarks,Expected to be Started On,Expected Closure On,Plan Created On,Plan Created From,Planned by User,Plan Approved by User,Intimate to Conduct N Days Before,Lead Auditor User,Lead Auditor Comments,Vendor Name,Vendor Status,Question and Answer Section Type,Initiated On,Started On,Completed On,Questionnaire Sent to Vendor On,Report Sent to Vendor On,Report Sent to Vendor By,Response Received from Vendor On,Audit Overall Outcome,Audit Conclusion,Executive Summary,Audit Outcome Status,Is Risk Calculation Required,Final Risk Score,Final Risk Status,Final Number Generated,Created On,Created by User,Updated On,Updated by User,Last Action On,Last Action by User,Last Action Comments,Last Action from Status,Stage Sequence,Stage Name";
        } else if (this.qmsservice.moduleName == "AU") {
          tname = "QMS_AU_TASKS_INTERVALS_REP_VW";
          colList = "TEMP_AU_NO,AU_ID,SCHEDULE_NO,ANNUAL_REF_NO,SUB_GROUP_NAME,DEPT_NAME,FUNCTIONAL_AREA_OR_SERVICES,AUDIT_TYPE,AUDIT_CATEGORY,AUDIT_CLASSIFICATION,AUDIT_PROPOSED_DATE,START_DATE,END_DATE,SHORT_DESCRIPTION,PEER_REVIEW_COMPLETED_ON,STATUS,EXTENSIONS,MULTIPLE_PLANS,SCHEDULE_STATUS,SCHEDULED_BY_USER,SCHEDULE_APPROVED_BY_USER,INTIMATE_TO_PLAN_N_DAYS_BEFORE,PLAN_CREATED_ON,PLAN_CREATED_FROM,PLANNED_BY_USER,PLAN_APPROVED_BY_USER,INTIMATE_TO_CONDUCT_N_DAYS_BEFORE,LEAD_AUDITOR_USER,LEAD_AUDITOR_COMMENTS,VENDOR_NAME,VENDOR_STATUS,AUDIT_DEPARTMENT,AUDIT_ADDRESS,AUDIT_MASTER_ID,AUDIT_PURPOSE,AUDIT_SCOPE,AUDIT_REFERENCES,EXECUTIVE_SUMMARY,PLAN_APPROVAL_REQUESTED_ON,PLAN_APPROVED_ON,SCHEDULE_APPROVAL_REQUESTED_ON,SCHEDULE_APPROVED_ON,REMARKS,QUESTION_AND_ANSWER_SECTION_TYPE,EXPECTED_TO_BE_STARTED_ON,INITIATED_ON,STARTED_ON,EXPCETED_CLOSURE_ON,COMPLETED_ON,QUESTIONNAIRE_SENT_TO_VENDOR_ON,REPORT_SENT_TO_VENDOR_ON,REPORT_SENT_TO_VENDOR_BY,AUDIT_OVERALL_OUTCOME,AUDIT_OUTCOME_STATUS,CONCLUSION,RESPONSE_RECEIVED_FROM_VENDOR_ON,IS_RISK_CALCULATION_REQD,FINAL_RISK_SCORE,FINAL_RISK_STATUS,FINAL_NO_GENERATED";
          fieldList = "Temporary AU Number,AU ID,Schedule Number,Annual Reference Number,Subgroup Name,Department Name,Functional Area or Services,Audit Type,Audit Category,Audit Classification,Audit Proposed Date,Start Date,End Date,Short Description,Peer Review Completed On,Status,Extensions,Multiple Plans,Schedule Status,Schedule By,Schedule Approver,Intimate to Plan N Days Before,Plan Created On,Plan Created From,Plan By,Plan Approver,Intimate to Conduct N Days Before,Lead Auditor,Lead Auditor Comments,Vendor Name,Vendor Status,Audit Department,Audit Address,Audit Master ID,Audit Purpose,Audit Scope,Audit References,Executive Summary,Plan Approval Requested On,Plan Approved On,Schedule Approval Requested On,Schedule Approved On,Remarks,Question and Answer Section Type,Expected to Be Started On,Initiated On,Started On,Expected Closure On,Completed On,Questionnaire Sent to Vendor On,Report Sent to Vendor On,Report Sent to Vendor By,Audit Overall Outcome,Audit Outcome Status,Conclusion,Response Received from Vendor On,Is Risk Calculation Required,Final Risk Score,Final Risk Status,Final Number Generated";
        } else {
          if (this.qmsservice.moduleName == "CR") {
            tname = "QMS_CR_REPORT_VW";
          } else if (this.qmsservice.moduleName == "CAPA") {
            tname = "QMS_CAPA_REPORT_VW";
          } else if (this.qmsservice.moduleName == "DV") {
            tname = "QMS_DV_REPORT_VW";
          } else if (this.qmsservice.moduleName == "IN") {
            tname = "QMS_IN_REPORT_VW";
          } else if (this.qmsservice.moduleName == "CC") {
            tname = "QMS_CC_REPORT_VW";
          } else if (this.qmsservice.moduleName == "QI") {
            tname = "QMS_QI_REPORT_VW";
          } else if (this.qmsservice.moduleName == "OOS") {
            tname = "QMS_OOS_REPORT_VW"
          }
          colList = this.columnsListForExcel;
          fieldList = this.fieldLabelsListForExcel;
          invisibleList = this.invisibleColumnForExcel;
        }

      } else if (this.showReportFlagValue == 2) {
        tname = "QMS_ALL_TASK_EXTENSIONS_REP_VW";
        colList = "TASK_ID,EXTENSION_ID,CURRENT_DUE_DATE,EXTENSION_REQUIRED_TILL,JUSTIFICATION,STATUS,REVIEW_REQUESTED_ON,REVIEWER,REVIEWED_ON,REVIEW_COMMENTS,APPROVE_REQUESTED_ON,APPROVED_BY,APPROVER,APPROVED_ON,APPROVER_COMMENTS,CREATED_BY_USER,EXTENSION_TYPE,ACTION_DETAILS";
        fieldList = `${this.qmsservice.moduleName} ID,Extension ID,Current Due Date,Extension Required Till,Justification,Status,Review Requested On,Reviewer,Reviewed On,Review Comments,Approve Requested On,Approved By,Approver,Approved On,Approver Comments,Created By,Extension Type,Action Details`;
        this.onlyDateColumn = "CURRENT_DUE_DATE,EXTENSION_REQUIRED_TILL";
      } else if (this.showReportFlagValue == 3) {
        tname = "QMS_ALL_TASK_EC_REP_VW";
        colList = "DUE_DATE,METHODOLOGY,CRITERIA,CONCLUSION,OUTCOME,CLOSURE_COMMENTS,APPROVAL_REQUESTED_ON,APPROVAL_COMMENTS,APPROVED_ON,APPROVER,QA_APPROVAL_REQUESTED_ON,QA_APPROVED_ON,QA_APPROVER,QA_APPROVAL_COMMENTS,REMIND_N_DAYS_BEFORE_DUE_DATE,CREATED_BY_USER,SEQ,AXIS_VALUE,INTERVALS,TASK_ID,EC_ID,TRIGGERED_FROM_EC_ID,CHECK_REQD_FOR,STATUS,OWNER_NAME,START_DATE";
        fieldList = "Due Date,Methodology,Criteria,Conclusion,Outcome,Closure Comments,Approval Requested On,Approval Comments,Approved On,Approver,QA Approval Requested On,QA Approved On,QA Approver,QA Approval Comments,Remind N Days Before Due Date,Created By User,Seq,Axis Value,Intervals,Task ID,EC ID,Triggered From EC ID,Check Reqd For,Staus,Owner Name,Start Date";

      } else if (this.showReportFlagValue == 4) {
        tname = "QMS_ALL_TASK_ACTIONS_REP_VW";
        colList = "TASK_ID,SL_NO,ACTION_ID,ACTION_NAME,STARTED_ON,STATUS,TARGET_DATE,ACTION_AT,CORE_BUSINESS_AREA,ASSIGNED_TO,ASSIGNED_TO_DEPARTMENT,COMMENTS,ACTION_PERFORMED,REVIEW_REQUESTED_ON,REVIEWER,REVIEW_STATUS,REVIEW_COMMENTS,REVIEW_COMPLETED_ON,APPROVAL_REQUESTED_ON,APPROVER,APPROVAL_STATUS,APPROVAL_COMMENTS,APPROVAL_COMPLETED_ON,DEFER_REVIEWER,DEFER_APPROVER,CREATED_ON,CREATED_BY_USER,SEQ,AXIS_VALUE,INTERVALS";
        fieldList = this.qmsservice.moduleName + " ID,SL NO,Action ID,Action Name,Started On,Status,Target Date,Action At,Core Business Area,Assigned To,Assigned To Department,Comments,Action Performed,Review Requested On,Reviewer,Review Status,Review Comments,Review Completed On,Approval Requested On,Approver,Approval Status,Approval Comments,Approval Completed On,Defer Reviewer,Defer Approver,Created On,Created By User,Seq,Axis Value,Intervals";
        this.onlyDateColumn = "TARGET_DATE";
      } else if (this.showReportFlagValue == 5) {
        tname = "QMS_ALL_TASK_FINDINGS_INTERVAL_REP_VW";
        colList = "AU_ID,FINDING_ID,SEQ,FINDING,STATUS,ANNUAL_REF_NO,SUB_GROUP_NAME,DUE_DATE,ASSIGNED_TO_USER_NAME,ASSIGNED_TO_DEPARTMENT,FINDING_SHORT_DESCRIPTION,REFERENCE,DELIVERABLES,SEVERITY,AUDITOR_COMMENTS,ROOT_CAUSE_ANALYSIS,IMMEDIATE_CORRECTION,CORRECTIVE_ACTION,PREVENTIVE_ACTION,EXPECTED_CA_CLOSURE_DATE,EXPECTED_PA_CLOSURE_DATE,EXPECTED_CLOSURE_DATE,IS_CAPA_REQUIRED,CAPA_DETAILS,RESPONSE_REVIEWED_BY_USER_NAME,RESPONSE_REVIEW_STATUS,RESPONSE_REVIEW_COMPLETED_ON,RESPONSE_REVIEWER_COMMENTS,RESPONSE_VERIFICATION_REQUESTED_ON,RESPONSE_VERIFIED_ON,RESPONSE_VERIFICATION_COMMENTS,IMPLEMENTATION_REVIEWED_BY_USER_NAME,IMPLEMENTATION_REVIEW_STATUS,IMPLEMENTATION_REVIEW_COMPLETED_ON,IMPLEMENTATION_REVIEWER_COMMENTS,IMPLEMENTATION_VERIFICATION_REQUESTED_ON,IMPLEMENTATION_VERIFIED_ON,IMPLEMENTATION_VERIFICATION_COMMENTS,IS_IMPLEMENTAITON_ACCEPTED,CLOSURE_COMMENTS,COMMENTS,COMPLETED_ON,FINAL_RISK_STATUS,FINAL_RISK_SCORE,RESPONSE_REVIEW_REQUESTED_ON,IMPLEMENTATION_REVIEW_REQUESTED_ON,CREATED_ON,CREATED_BY_NAME,UPDATED_ON,UPDATED_BY_NAME";
        fieldList = "Audit ID,Finding ID,Seq,Finding,Status,Annual Ref No,Sub Group Name,Response Due Date,Assigned To User,Assigned To Department,Finding Short Description,Reference,Deliverables,Severity,Auditor Comments,Root Cause Analysis,Immediate Correction,Corrective Action,Preventive Action,Expected CA Closure Date,Expected PA Closure Date,Expected Closure Date,Isolated CAPA Required,CAPA Details,Response Reviewed By User,Response Review Status,Response Review Completed On,Response Reviewer Comments,Response Verification Requested On,Response Verified On,Response Verification Comments,Implementation Reviewed By User,Implementation Review Status,Implementation Review Completed On,Implementation Reviewer Comments,Implementation Verification Requested On,Implementation Verified On,Implementation Verification Comments,Is Implementation Accepted,Closure Comments,Comments,Completed On,Final Risk Status,Final Risk Score,Response Review Requested On,Implementation Review Requested On,Created On,Created By,Updated On,Updated By";

      } else if (this.showReportFlagValue == 6) {
        tname = "QMS_ALL_TASK_FOLLOWUPS_INTERVAL_REP_VW";
        colList = "AU_ID,FINDING_ID,FOLLOWUP_ID,SUB_GROUP_NAME,ANNUAL_REF_NO,STATUS,AUDIT_DEPARTMENT,DUE_DATE,ASSIGNED_TO_USER_NAME,ASSIGNED_TO_DEPARTMENT,ASSIGNED_TO_USER_DETAILS,RESPONSES_PENDING,COMPLETED_ON,COMMENTS,CREATED_ON,CREATED_BY_NAME,UPDATED_ON,UPDATED_BY_NAME";
        fieldList = "Audit Id,Finding Id,Followup Id,Sub Group Name,Annual Ref No,Status,Audit Department,Due Date,Assigned To User,Assigned To Department,Assigned To User Details,Responses Pending,Completed On,Comments,Created On,Created By,Updated On,Updated By";
      } else if (this.showReportFlagValue == 7) {
        tname = "QMS_ALL_TASK_RECOMMENDATION_INTERVAL_REP_VW";
        colList = "RECOMMENDATION_ID,SUB_GROUP_NAME,ANNUAL_REF_NO,DESCRIPTION,REFERENCE_DETAILS,AUDITEE_COMMENTS,CREATED_BY_NAME,CREATED_ON,UPDATED_BY_NAME,UPDATED_ON";
        fieldList = "Recommendation Id,Sub Group Name,Annual Ref No,Description,Reference Details,Auditee Comments,Created By,Created On,Updated By,Updated On";

      } else if (this.showReportFlagValue == 8) {
        if (this.qmsservice.moduleName == "AU") {
          tname = "QMS_ALL_TASKS_DUEINDAYS_VW";
          colList = "TASK_ID,DUE_IN_DAYS,MODULE,EXPCETED_CLOSURE_ON,EXPECTED_TO_BE_STARTED_ON,SHORT_DESCRIPTION,TASK_TYPE,INITIATOR_FULLNAME,OWNER_FULLNAME,QA_ACCEPTOR_NAME,LAST_ACTION_FROM_STATUS,LAST_ACTION_ON,STATUS,STOP_REMINDERS,STAGE_NAME,CREATED_ON,EFFECTIVENESS_CHECK_REQD, FINAL_NO_GENERATED,FINAL_RISK_STATUS,INVESTIGATION_REQUIRED,INVESTIGATOR_FULLNAME,IS_QANDA_REQD,COMPLETED_ON,STARTED_ON";
          fieldList = `${this.qmsservice.moduleName} ID,Due In Days,Module,Expected Closure On,Expected To Be Started On,Short Description,${this.qmsservice.moduleName} Type,Initiator Fullname,Owner,Qa Acceptor Name,Last Action From Status,Last Action On,Status,Stop Reminders,Stage Name,Created On,Effectiveness Check Reqd,Final No Generated,Final Risk Status,Investigation Required,Investigator,Is Q and a Reqd,Completed On,Started On`;
        } else {
          tname = "QMS_ALL_TASKS_DUEINDAYS_VW";
          colList = "TASK_ID,DUE_IN_DAYS,MODULE,EXPCETED_CLOSURE_ON,EXPECTED_TO_BE_STARTED_ON,SHORT_DESCRIPTION,TASK_TYPE,REQUESTED_AT,CORE_BUSINESS_AREA_NAME,INITIATOR_FULLNAME,OWNER_FULLNAME,QA_ACCEPTOR_NAME,LAST_ACTION_FROM_STATUS,LAST_ACTION_ON,STATUS,STOP_REMINDERS,STAGE_NAME,CREATED_ON,EFFECTIVENESS_CHECK_REQD, FINAL_NO_GENERATED,FINAL_RISK_STATUS,INVESTIGATION_REQUIRED,INVESTIGATOR_FULLNAME,IS_QANDA_REQD,COMPLETED_ON,STARTED_ON";
          fieldList = `${this.qmsservice.moduleName} ID,Due In Days,Module,Expected Closure On,Expected To Be Started On,Short Description,${this.qmsservice.moduleName} Type,Requested At,Business Area,Initiator Fullname,Owner,Qa Acceptor Name,Last Action From Status,Last Action On,Status,Stop Reminders,Stage Name,Created On,Effectiveness Check Reqd,Final No Generated,Final Risk Status,Investigation Required,Investigator,Is Q and a Reqd,Completed On,Started On`;

        }
      }


      const data = {

        groupId: this.qmsservice.selectedGroup
      }

      const data1: any = {

        tableOrViewName: tname,
        columnsList: colList,
        fieldLabelsList: fieldList,
        invisibleColumn: invisibleList,
        orderByClause: "",
        fieldSizeList: "",
        columnsListarray: [],
        fieldColumnarray: [],
        invisibleColumnarray: [],
        fieldSizeListArray: [],
        status: this.statusCodeValue,
        codelistGroup: null,
        manualEntryDataFields: this.onlyDateColumn,
        groupId: this.qmsservice.selectedActivityGroupId,
        chartStatus: "null",
        reModule: "qms1",
        logoId: this.selectedReportLogoValue ?? 0,
        isSaveRep: this.isSaveReport ? 'Y' : 'N',
        footer: this.selectedReportFooter,
        reportName: this.reportName ?? `${this.clickedType}_${this.clickedVal}`,
        currentStatus: "NA",
        groupName: this.qmsservice.activity.groupName + "",
      }
      let dateRangeAt;
      if (this.qmsservice.moduleName === 'AU') {
        dateRangeAt = this.selectedAuDateRangeValue ? this.selectedAuDateRangeValue : null;
      } else {
        dateRangeAt = this.selectedDateRangeValue ? this.selectedDateRangeValue : null;
      }
      let selectedQmsDept1 = "";
      if (this.selectedQmsDept.length != 0) {
        for (let j = 0; j < this.selectedQmsDept.length; j++) {
          selectedQmsDept1 += this.selectedQmsDept[j];
          selectedQmsDept1 += j == this.selectedQmsDept.length - 1 ? "" : ",";
        }
      }
      if (this.annualRefNo) {
        this.whereValsForExcel = this.whereValsForExcel + " AND ANNUAL_REF_NO='" + this.annualRefNo + "'";
      }
      let data2 = {

        groupId: this.selectedGroupValue ? this.selectedGroupValue : null,
        module: this.qmsservice.moduleName,
        dateRangeAt: dateRangeAt,
        fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
        toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
        intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
        deptCode: selectedQmsDept1 ?? null,
        stageName: this.selectedStageValue ? this.selectedStageValue : null,
        status: this.selectedStatusValue ? this.selectedStatusValue : null,
        wherVal: this.whereValsForExcel
      }
      this.reportObj = { ...data1, ...data, ...data2 };
      const timestamp = Date.now();
      const formattedDate = new Intl.DateTimeFormat('en-US', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      })
        .format(new Date(timestamp))
        .replaceAll(',', '')
        .replaceAll(' ', '_');
      let fileType = value == 'Excel' ? 'xlsx' : 'pdf';
      const fileName = `${this.clickedType}_${this.clickedVal}_${formattedDate}.${fileType}`;
      if (value == 'Excel') {
        const pdfData = {
          ...this.reportObj, title: "Report", columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnList.split(',').join(','),
          "informationTab": {
            "Report Name": `${this.clickedType}_${this.clickedVal}` + "Report",
            "Exported By": sessionStorage.getItem("reportsUserName")
          }
        }
        this.appService.downloadexcelForChartWithColumns(pdfData, fileName + Date.now() + ".xlsx");
      } else {
        if ((this.qmsservice.moduleName == "AU" && this.showReportFlagValue == 1) || this.showReportFlagValue == 2 || this.showReportFlagValue == 3 || this.showReportFlagValue == 4 || this.showReportFlagValue == 5 || this.showReportFlagValue == 6 || this.showReportFlagValue == 7 || this.showReportFlagValue == 8) {
          const pdfData = {
            ...this.reportObj, title: `${this.clickedType}_${this.clickedVal}` + " Report", columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnList.split(',').slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
          }
          this.appService.downloadPdfForChart(pdfData, fileName + Date.now() + ".pdf");
        } else {
          const pdfData = {
            ...this.reportObj, title: `${this.clickedType}_${this.clickedVal}` + " Report", columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray).slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
          }
          this.appService.downloadPdfForChart(pdfData, fileName + Date.now() + ".pdf");
        }
      }
    }
  }

  openReportPopup(item: any) {
    if (this.qmsservice.moduleName == "AU" && this.showReportFlagValue == 1) {
      this.excelPdf.dropDown = this.columnList.split(',').map((column: any) => ({ valueExp: column, displayExp: column }));
    } else if (this.showReportFlagValue == 2 || this.showReportFlagValue == 3 || this.showReportFlagValue == 4 || this.showReportFlagValue == 5 || this.showReportFlagValue == 6 || this.showReportFlagValue == 7 || this.showReportFlagValue == 8) {
      this.excelPdf.dropDown = this.columnList.split(',').map((column: any) => ({ valueExp: column, displayExp: column }));
    } else {
      this.excelPdf.dropDown = this.columnLists.fieldColumnarray.map((column: any) => ({ valueExp: column.fieldColumnarray, displayExp: column.fieldColumnarray }));
    }

    this.pdfPageSizes = JSON.parse(sessionStorage.getItem('pdfPageSizes') ?? '{}');
    this.excelPdf.pdfPageSize = 'A4';
    this.isForExcel = item == 'Excel';
    this.popupDataTitle.title = item == 'Excel' ? 'Excel Report' : 'PDF Report';
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];

    const firstst = this.message.breadcrumbData.firstLevel;
    const secondnd = this.message.breadcrumbData.secondLevel;
    const thirdL = this.message.breadcrumbData.thirdLevel;
    const fourthL = this.message.breadcrumbData.fourthLevel;
    let fileName = "";
    if (firstst != null) {
      fileName = firstst + "_";
    }
    if (secondnd != null) {
      fileName = fileName + secondnd + "_";
    }
    if (thirdL != null) {
      fileName = fileName + thirdL + "_";
    }
    if (fourthL != null) {
      fileName = fileName + fourthL + "_";
    }
    this.reportName = fileName + Date.now();
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopup, this.excelPdfPopupConfig);
    this.pdfColumnSelection = false;
    this.isSaveReport = false;
  }
  //end excell & pdf
  manuallyPicked: boolean;
  pdfSearchText: string = '';
  maxCountReached: boolean = false;
  selectedColumnsAsString: string = "";
  pdfPageSizes: any = [];
  @Input() excelPdf: any = {};

  convertArrayToString(array: any) {
    this.selectedColumnsAsString = array.join(', ');
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }
  onCheckboxChange(event: MatSlideToggleChange) {
    if (!event.checked) {
      [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    }
  }
  selectBoxeForDepartmentCode() {
    for (const department of this.dropDownForDepartmentCode) {
      this.departmentCodeDropdown = this.departmentCodeDropdown.concat({
        valueExp: department.codelistCode,
        displayExp: department.codelistName
      });
    }
  }
  onDepartmentCodeSelect(item: any) {
    this.selectedDepartmentValue = item.valueExp;
  }
  onDepartmentCodeRemoved(item: any) { }
  onColumnSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
        this.pdfColumnSelection = this.selectedColumns.length == this.excelPdf.dropDown.length;
      });
    }
  }
  //more activity
  moreActivityReportDetails(value: any) {
    if (value == "Default") {
      this.qmsservice.reportFor = value;
      this.router.navigate(['/dashboard/ActivityReportComponent/', this.qmsservice.moduleName]);
    } else {
      this.qmsservice.reportFor = value;
      this.message.breadcrumbData.thirdLevel = value;
      this.router.navigate(['/dashboard/MoreActivityReportDetailsComponent/', this.qmsservice.moduleName]);
    }
  }
  auditFindingReportDetails(value: any) {
    if (value == "Default") {
      this.qmsservice.reportFor = value;
      this.router.navigate(['/dashboard/ActivityReportComponent/', this.qmsservice.moduleName]);
    } else {
      this.qmsservice.reportFor = value;
      this.message.breadcrumbData.thirdLevel = value;
      this.router.navigate(['/dashboard/AuditReportFindingDetailComponent/', this.qmsservice.moduleName]);
    }
  }
  findingDueDate(value: any) {
    if (value == "Default") {
      this.qmsservice.reportFor = value;
      this.router.navigate(['/dashboard/ActivityReportComponent/', this.qmsservice.moduleName]);
    } else {
      this.qmsservice.reportFor = value;
      this.message.breadcrumbData.thirdLevel = value;
      this.router.navigate(['/dashboard/findingDueDate/', this.qmsservice.moduleName]);
    }
  }
  followupDueDate(value: any) {
    if (value == "Default") {
      this.qmsservice.reportFor = value;
      this.router.navigate(['/dashboard/ActivityReportComponent/', this.qmsservice.moduleName]);
    } else {
      this.qmsservice.reportFor = value;
      this.message.breadcrumbData.thirdLevel = value;
      this.router.navigate(['/dashboard/followupDueDate/', this.qmsservice.moduleName]);
    }
  }
  columnsListForExcel: any;
  fieldLabelsListForExcel: any;
  invisibleColumnForExcel: any;
  dynamicGridName: any;
  dynamicGridViewName: any;
  snackbarRef: any;
  searchText: any;
  _temp: any = {};
  activityRepVwDataForGrid: any = [];
  visibleDataGrid: boolean = false;

  getcallMethod(whereVals: any, type: any) {
    console.log("getcallMethod")
    this.activityRepVwDataForGrid = [];
    const data = {

      groupId: this.selectedGroupValue ? this.selectedGroupValue : null,
      gridName: this.dynamicGridName,
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        this.columnsListForExcel = response.columnsList ?? "";
        this.fieldLabelsListForExcel = response.fieldLabelsList ?? "";
        this.invisibleColumnForExcel = response.invisibleColumn ?? "";
        this.makeStickyColumns = response.fixedFieldCnt;
        this.columnList = this.fieldLabelsListForExcel;
        const data1: any = {

          gridName: this.dynamicGridViewName,
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }
        let dateRangeAt = null;
        if (this.qmsservice.moduleName === 'AU') {
          dateRangeAt = this.selectedAuDateRangeValue || null;
        } else {
          dateRangeAt = this.selectedDateRangeValue || null;
        }
        let wherVal: string;
        if (whereVals === '') {
          wherVal = " WHERE ORG_ID=?1 ";
        } else if (type === 'ba') {
          wherVal = this.baWhereVals;
        } else {
          wherVal = whereVals + " AND ORG_ID=?1 ";
        }

        let selectedQmsDept1 = "";
        if (this.selectedQmsDept.length != 0) {
          for (let j = 0; j < this.selectedQmsDept.length; j++) {
            selectedQmsDept1 += this.selectedQmsDept[j];
            selectedQmsDept1 += j == this.selectedQmsDept.length - 1 ? "" : ",";
          }
        }
        let data2 = {
          groupId: this.selectedGroupValue ? this.selectedGroupValue.toString() : null,
          module: this.qmsservice.moduleName,
          dateRangeAt: dateRangeAt,
          fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
          toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
          intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
          stageName: this.selectedStageValue ? this.selectedStageValue : null,
          status: this.selectedStatusValue ? this.selectedStatusValue : null,
          deptCode: selectedQmsDept1 ?? null,
          annualRefNo: this.annualRefNo ?? null,
          wherVal: wherVal,
          reModule: "qms"
        }

        this.reportObj = { ...data1, ...data, ...data2 };
        this.appService.getDynamicGridData(this.reportObj).subscribe({
          next: (response1: any) => {
            this.activityRepVwDataForGrid = response1;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const size of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(size + 'px');
            }
            for (let y = this.columnLists.columnsListarray.length - 1; y >= 0; y--) {
              if (this.columnLists.invisibleColumnarray.includes(this.columnLists.columnsListarray[y])) {
                this.columnLists.columnsListarray.splice(y, 1);
                this.columnLists.fieldColumnarray.splice(y, 1);
                this.columnLists.fieldSizeListArray.splice(y, 1);
              }
            }
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const dataType of this.dataTypeList) {
                  if (dataType.columnName === this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = dataType.fieldType;
                  }
                }
              }
              for (const record of this.activityRepVwDataForGrid) {
                for (const dataType of this.dataTypeList) {
                  if (dataType.fieldType === 'CHECKBOX') {
                    record[dataType.columnName] = record[dataType.columnName] === "Y";
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
            });
            this.message.gridList = this.activityRepVwDataForGrid;
            this.collectionSize = this.activityRepVwDataForGrid.length;
            this.totalPages = Math.ceil(this.activityRepVwDataForGrid.length / this.itemsPerPage);
            this.isProcessing = false;
          }, error: (error: any) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }


  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.activityRepVwDataForGrid.length, page, this.perPage, targetpage);
    if (this.activityRepVwDataForGrid.length > 0) {
      this.pagedItems = this.activityRepVwDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  getClobData3(list: any, colunName: any) {
    this.isProcessing = true;
    let modifiedColumnName = colunName;
    switch (colunName) {
      case "CHANGE_DESCRIPTION":
        modifiedColumnName = "Change Description";
        break;
      case "CURRENT_STATE":
        modifiedColumnName = "Current State";
        break;
      case "PROPOSED_CHANGE":
        modifiedColumnName = "Proposed Change";
        break;
      case "CHANGE_JUSTIFICATION":
        modifiedColumnName = "Change Justification";
        break;
      case "RISK_ASSESSMENT":
        modifiedColumnName = "Risk Assessment";
        break;
      case "DV_DESCRIPTION":
        modifiedColumnName = "Deviation Description";
        break;
      case "SCOPE":
        modifiedColumnName = "Scope";
        break;
      case "INITIAL_ASSESSMENT":
        modifiedColumnName = "Initial Assessment";
        break;
      case "INVESTIGATION_PLAN":
        modifiedColumnName = "Investigation Plan";
        break;
      case "INVESTIGATION_DETAILS":
        modifiedColumnName = "Investigation Details";
        break;
      case "ROOT_CAUSE_ANALYSIS":
        modifiedColumnName = "Root Cause Analysis";
        break;
      case "IMPACT_ASSESSMENT":
        modifiedColumnName = "Impact Assessment";
        break;
      case "CONCLUSION":
        modifiedColumnName = "Conclusion";
        break;
      case "LAST_ACTION_COMMENTS":
        modifiedColumnName = "Last Action Comments";
        break;
      case "REPORTER_COMMENTS":
        modifiedColumnName = "Reporter Comments";
        break;
      case "ROOT_CAUSE":
        modifiedColumnName = "Root Cause";
        break;
      default:
        break;
    }
    let tempView;
    if (list.tablevwname == "QMS_CR_REPORT_VW") {
      tempView = "QMS_CR_VW"
    } else if (list.tablevwname == "QMS_CAPA_REPORT_VW") {
      tempView = "QMS_CAPA_VW"
    } else if (list.tablevwname == "QMS_DV_REPORT_VW") {
      tempView = "QMS_DV_VW"
    } else if (list.tablevwname == "QMS_AU_REPORT_VW") {
      tempView = "QMS_AU_VW"
    } else if (list.tablevwname == "QMS_IN_REPORT_VW") {
      tempView = "QMS_IN_VW"
    } else if (list.tablevwname == "QMS_QI_REPORT_VW") {
      tempView = "QMS_QI_VW"
    } else if (list.tablevwname == "QMS_CC_REPORT_VW") {
      tempView = "QMS_CC_GRID_VW"
    } else if (list.tablevwname == "QMS_OOS_REPORT_VW") {
      tempView = "QMS_OOS_VW"
    }

    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: tempView,
      columnName: colunName,
    };

    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, modifiedColumnName);
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
    this.isProcessing = false;
  }
  viewShortDescription(shortDescription: string) {
    this.isProcessing = true;
    this.htmlContent = shortDescription;
    this.editorComponent.openEditor(this.htmlContent, 'Short Description');
    this.isProcessing = false;
  }
  viewImpactedProduct(impactedProduct: string) {
    this.isProcessing = true;
    this.htmlContent = impactedProduct;
    this.editorComponent.openEditor(this.htmlContent, 'Impacted Product and Process');
    this.isProcessing = false;
  }
  viewLastActionComment(lastAction: string) {
    this.isProcessing = true;
    this.htmlContent = lastAction;
    this.editorComponent.openEditor(this.htmlContent, 'Last Action Comments');
    this.isProcessing = false;
  }
  viewClosureComment(closureComments: string) {
    this.isProcessing = true;
    this.htmlContent = closureComments;
    this.editorComponent.openEditor(this.htmlContent, 'Closure Comments');
    this.isProcessing = false;
  }
  viewLastAddComment(addlComments: string) {
    this.isProcessing = true;
    this.htmlContent = addlComments;
    this.editorComponent.openEditor(this.htmlContent, 'Addl Comments');
    this.isProcessing = false;
  }
  viewOccuranceReason(occuranceReason: string) {
    this.isProcessing = true;
    this.htmlContent = occuranceReason;
    this.editorComponent.openEditor(this.htmlContent, 'Occurance Reason');
    this.isProcessing = false;
  }
  viewResolutionProvided(resolutionProvided: string) {
    this.isProcessing = true;
    this.htmlContent = resolutionProvided;
    this.editorComponent.openEditor(this.htmlContent, 'Resolution Provided');
    this.isProcessing = false;
  }


  applyFilter33(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.activityRepVwDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.activityRepVwDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }
  groupSearchText: string = '';
  deptSearchText: string = '';
  dateRangeSearchText: string = '';
  intervalSearchText: string = '';
  stageSearchText: string = '';
  statusSearchText: string = '';
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }
  onGroupValueSelect1st(item: any) {
    this.handleDropDownValidation('groupNameAlert', item)
  }
  onGroupValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('groupNameAlert', item)
    }
  }
  @ViewChild('columns') columns: MatSelect;
  isAllColumns = false;
  @ViewChild('pdf') pdf: MatSelect;
  pdfColumnSelection = false;
  toggleAllSelection(value: any) {
    if (value == 'pdf') {
      if (this.pdfColumnSelection) this.pdf.options.forEach((item: MatOption) => item.select());
      else {
        this.pdf.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('execl-pdf', this.selectedColumns)
        this.convertArrayToString(this.selectedColumns);
      });

    } else if (value == 'columns') {
      if (this.isAllColumns) this.columns.options.forEach((item: MatOption) => item.select());
      else {
        this.columns.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];
      }
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
      });
    }
  }
  onPDFSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.pdfColumnSelection = this.excelPdf.dropDown.length == this.selectedColumns.length;
        this.convertArrayToString(this.selectedColumns);
      })
    }
  }

  ngOnChanges() {
    this.message.breadcrumbData.secondLevel = "";
    this.message.breadcrumbData.thirdLevel = "";
    this.message.breadcrumbData.fourthLevel = "";
    if (this.breadcrumbComponent) {
      this.breadcrumbComponent.secondLevel = "";
      this.breadcrumbComponent.thirdLevel = "";
      this.breadcrumbComponent.fourthLevel = "";
    }
    this.message.breadcrumbData.secondLevel = this.qmsservice.moduleName + " > " + this.qmsservice.SelectedGroupNameAndValue[0].displayExp;
    this.message.breadcrumbData.thirdLevel = 'Report';
    this.message.breadcrumbData.fourthLevel = this.qmsservice.reportFor;
    if (this.breadcrumbComponent) {
      this.breadcrumbComponent.secondLevel = this.qmsservice.moduleName + " > " + this.qmsservice.SelectedGroupNameAndValue[0].displayExp;
      this.breadcrumbComponent.thirdLevel = 'Report';
      this.breadcrumbComponent.fourthLevel = this.qmsservice.reportFor;
    }
    this.refreshbreadcrumb = true;
  }
  dropDownDataForReportLogo: any;
  selectedReportLogoValue: any = null;

  reportLogoDropdown: any = [];
  imageIdList: any = [];
  organizationReportImageDetails: any = {};
  logoVals: any;
  selectBoxForReportLogo() {
    this.reportLogoDropdown = [];
    if (this.dropDownDataForReportLogo) {
      if (this.dropDownDataForReportLogo.reportImageList == 'Default') {
        this.reportLogoDropdown = this.reportLogoDropdown.concat({
          valueExp: 0,
          displayExp: 'Default'
        });
      } else if (this.dropDownDataForReportLogo.reportImageList.includes(",")) {
        this.imageIdList = this.dropDownDataForReportLogo.reportImageList.split(",");
        for (let i = 0; i < this.imageIdList.length; i++) {
          if (i == 0 && this.imageIdList[i] == 'Default') {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: 0,
              displayExp: 'Default'
            });
          } else {
            for (const item of this.organizationReportImageDetails) {
              if (item.reportImageId === this.imageIdList[i]) {
                this.reportLogoDropdown.push({
                  valueExp: item.reportImageId,
                  displayExp: item.reportImageName
                });
              }
            }
          }
        }
      } else {
        for (const detail of this.organizationReportImageDetails) {
          if (detail.reportImageId === this.dropDownDataForReportLogo.reportImageList) {
            this.reportLogoDropdown.push({
              valueExp: detail.reportImageId,
              displayExp: detail.reportImageName,
            });
          }
        }
      }
      if (this.dropDownDataForReportLogo.defaultReportName != 'Default' && this.dropDownDataForReportLogo.defaultReportName != null) {
        for (const item of this.reportLogoDropdown) {
          if (item.valueExp === this.dropDownDataForReportLogo.defaultReportName) {
            this.selectedReportLogoValue = item.valueExp;
            break; // Exit the loop once a match is found
          }
        }
      } else {
        this.selectedReportLogoValue = this.reportLogoDropdown[0].valueExp;
      }
    } else {
      this.selectedReportLogoValue = [];
    }
  }
  ngOnInit() {
    this.route.params.subscribe(params => {
      this.resetFunction1();
      this.selectedIntervalValue = 'MONTH';
      this.selectedDateRangeValue = 'CREATED';
      this.selectedAuDateRangeValue = 'STARTED';
      this.selectedGroupValue = this.qmsservice.SelectedGroupNameAndValue[0].valueExp;
      this.selectedGroupNameForBredcrumb = this.qmsservice.SelectedGroupNameAndValue[0].displayExp;
      this.refreshbreadcrumb = false;
      this.ngOnChanges();
      this.ngOnChanges();
      this.isProcessing = true;
      this.qmsservice.reportFor = 'Default';
      this.onGroupValueSelect1st({ valueExp: this.qmsservice.SelectedGroupNameAndValue[0].valueExp, displayExp: this.qmsservice.SelectedGroupNameAndValue[0].displayExp });
      if (this.selectedGroupValue) {
        this.genReport()
      }
      this.datePickerConfiguration = {
        dateInputFormat: 'DD-MMM-YYYY',
        showWeekNumbers: false,
        containerClass: 'theme-dark-blue',
        showTodayButton: false,
        todayPosition: 'center',
        minDate: this.minDate,
        maxDate: this.maxDate
      };



      forkJoin([
        this.appService.getCodeListsByGroup('AUDIT_REPORT_DATERANGE'),
        this.appService.getCodeListsByGroup('REPORT_DATE_RANGE'),
        this.appService.getCodeListsByGroup('REPORT_INTERVAL'),
        this.appService.getCodeListsByGroup('DEPARTMENT'),
        this.appService.getCodeListsByGroup('AUDIT_DEPARTMENT'),
        this.appService.getQmsReportUsers(this.qmsservice.moduleName),
        this.appService.getStagesAndStatus(this.qmsservice.moduleName),
        this.appService.getOneQmsOrganizationReportImage(),
        this.appService.getQmsReportLogoByModuleAndGroupId("QMS", this.qmsservice.SelectedGroupNameAndValue[0].valueExp)
      ]).subscribe(([dateRangeForAu, typdropDownForDateRangeData, typdropDownForIntervalData, department, auditDepartment, groupdataList, stageAndStatus, data, data1]) => {
        this.organizationReportImageDetails = data;
        this.dropDownDataForReportLogo = data1;
        this.selectBoxForReportLogo();
        this.dropDownForAuDateRange = dateRangeForAu;
        this.selectBoxForAuDateRange();
        this.dropDownForDateRange = typdropDownForDateRangeData;
        this.selectBoxForDateRange();
        this.dropDownForInterval = typdropDownForIntervalData;
        this.selectBoxForInterval();
        this.dropDownForDepartmentCode = this.qmsservice.moduleName == 'AU' ? auditDepartment : department;
        this.selectBoxeForDepartmentCode();
        this.groupdataList = groupdataList;
        this.selectBoxeForGroupValue();
        this.stageAndStatus = stageAndStatus;
        this.selectBoxeForStageValue();
        this.isProcessing = false;
      })
    });

    this.ngOnChangesReportFooter();
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.dynamicGridName, this.dynamicGridViewName, this.qmsservice.moduleName, this.qmsservice.selectedGroup)
  }
  onChildValueEmitted() {
    this.visibleReportPopup.close();
    this.genReport();
  };



  generateGroupSummary(val: any, ty: any): any[] {
    if (!val?.length) {
      return [];
    }
    const dataSummary: any = {};
    if (ty == 'stage') {
      val.forEach((item: any) => {
        const stageName = item.stageName?.trim();
        const count = Number(item.count) || 0;
        const key = stageName;
        if (!dataSummary[key]) {
          dataSummary[key] = {
            Stage: stageName,
            Count: 0
          };
        }
        dataSummary[key].Count += count;
      });
    } else if (ty == 'status' || ty == 'Recommendation' || ty == 'followup' || ty == 'finding') {
      val.forEach((item: any) => {
        const status = item.status?.trim();
        const count = Number(item.count) || 0;
        const key = status;
        if (!dataSummary[key]) {
          dataSummary[key] = {
            Status: status,
            Count: 0
          };
        }
        dataSummary[key].Count += count;
      });
    } else if (ty == 'ba') {
      val.forEach((item: any) => {
        const baValue = item.baValue?.trim();
        const count = Number(item.cnt) || 0;
        const key = baValue;
        if (!dataSummary[key]) {
          dataSummary[key] = {
            BusinessArea: baValue,
            Count: 0
          };
        }
        dataSummary[key].Count += count;
      });
    } else if (ty == 'dept') {
      val.forEach((item: any) => {
        const deptCode = item.deptCode?.trim();
        const count = Number(item.count) || 0;
        const key = deptCode;
        if (!dataSummary[key]) {
          dataSummary[key] = {
            Department: deptCode,
            Count: 0
          };
        }
        dataSummary[key].Count += count;
      });
    } else if (ty == 'ttype') {
      val.forEach((item: any) => {
        const taskType = item.taskType?.trim();
        const count = Number(item.count) || 0;
        const key = taskType;
        if (!dataSummary[key]) {
          dataSummary[key] = {
            Type: taskType,
            Count: 0
          };
        }
        dataSummary[key].Count += count;
      });
    } else if (ty == 'duein') {
      val.forEach((item: any) => {
        const dueInDays = item.dueInDays?.trim();
        const count = Number(item.count) || 0;
        const key = dueInDays;
        if (!dataSummary[key]) {
          dataSummary[key] = {
            DueInDays: dueInDays,
            Count: 0
          };
        }
        dataSummary[key].Count += count;
      });
    } else if (ty == 'severity') {
      val.forEach((item: any) => {
        const severity = item.severity?.trim();
        const count = Number(item.count) || 0;
        const key = severity;
        if (!dataSummary[key]) {
          dataSummary[key] = {
            Severity: severity,
            Count: 0
          };
        }
        dataSummary[key].Count += count;
      });
    } else if (ty == 'extention' || ty == 'ec' || ty == 'ec' || ty == 'action') {
      val.forEach((item: any) => {
        const axisValue = item.axisValue?.trim();
        const count = Number(item.count) || 0;
        const key = axisValue;
        if (!dataSummary[key]) {
          dataSummary[key] = {
            Interval: axisValue,
            Count: 0
          };
        }
        dataSummary[key].Count += count;
      });
    } else if (ty == 'oostype') {
      val.forEach((item: any) => {
        const taskType = item.taskType?.trim();
        const count = Number(item.count) || 0;
        const key = taskType;
        if (!dataSummary[key]) {
          dataSummary[key] = {
            OOSType: taskType,
            Count: 0
          };
        }
        dataSummary[key].Count += count;
      });
    }



    return Object.values(dataSummary);
  }


  exportExcelFromFrontendcall() {
    this.exportExcelFromFrontend(this.stageExcelList, this.statusExcelList, this.baExcelList, this.departmentExcelList, this.taskTypeExcelList, this.extensionExcelList, this.ecExcelList, this.actionExcelList, this.findingExcelList, this.followupExcelList, this.RecommendationExcelList, this.severityExcelList, this.dueInDaysExcelList)
  }

  exportExcelFromFrontend(stageExcelList: any, statusExcelList: any, baExcelList: any, departmentExcelList: any, taskTypeExcelList: any,
    extensionExcelList: any, ecExcelList: any, actionExcelList: any, findingExcelList: any, followupExcelList: any, RecommendationExcelList: any, severityExcelList: any, dueInDaysExcelList: any) {
    // 🔹 Information Sheet Data
    const infoData = [
      { Key: 'Report Name', Value: 'Module Summary Report' },
      { Key: 'Generated Date', Value: new Date().toLocaleDateString() },
      { Key: 'Generated Time', Value: new Date().toLocaleTimeString() },
      { Key: 'Generated By', Value: sessionStorage.getItem("reportsUserName") ? sessionStorage.getItem("reportsUserName") : localStorage.getItem("loggedUserName") }
    ];
    const infoWorksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(infoData);
    // 🔹 Module Summary Sheet
    const stageExcelListsheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(stageExcelList);
    const statusListsheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(statusExcelList);
    const baExcelListsheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(baExcelList);
    const departmentExcelListsheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(departmentExcelList);
    const taskTypeExcelListsheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(taskTypeExcelList);
    const extensionExcelListsheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(extensionExcelList);
    const ecExcelListsheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(ecExcelList);
    const actionExcelListsheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(actionExcelList);
    const findingExcelListsheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(findingExcelList);
    const followupExcelListsheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(followupExcelList);
    const RecommendationExcelListsheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(RecommendationExcelList);
    const severityExcelListsheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(severityExcelList);
    const dueInDaysExcelListsheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dueInDaysExcelList);
    // 🔹 Workbook with 2 sheets

    if (this.qmsservice.moduleName == "AU") {



      const workbook: XLSX.WorkBook = {

        Sheets: {
          'Information': infoWorksheet,
          'Stage': stageExcelListsheet,
          'Status': statusListsheet,
          'Business Area': baExcelListsheet,
          'Department': departmentExcelListsheet,
          'Task Type': taskTypeExcelListsheet,
          'Extension': extensionExcelListsheet,
          'EC': ecExcelListsheet,
          'Finding': findingExcelListsheet,
          'Followup': followupExcelListsheet,
          'Recommendation': RecommendationExcelListsheet,
          'Severity': severityExcelListsheet,
          'Due': dueInDaysExcelListsheet
        },
        SheetNames: ['Information', 'Stage', 'Status', 'Business Area', 'Department', 'Task Type', 'Extension', 'EC', 'Finding', 'Followup', 'Recommendation', 'Severity', 'Due In Days']
      };
      const excelBuffer: any = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });
      const blob: Blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      FileSaver.saveAs(blob, 'Module_Summary.xlsx');
    } else {
      const workbook: XLSX.WorkBook = {

        Sheets: {
          'Information': infoWorksheet,
          'Stage': stageExcelListsheet,
          'Status': statusListsheet,
          'Business Area': baExcelListsheet,
          'Department': departmentExcelListsheet,
          'Task Type': taskTypeExcelListsheet,
          'Extension': extensionExcelListsheet,
          'EC': ecExcelListsheet,
          'Action': actionExcelListsheet,
          'Due': dueInDaysExcelListsheet
        },
        SheetNames: ['Information', 'Stage', 'Status', 'Business Area', 'Department', 'Task Type', 'Extension', 'EC', 'Action', 'Due']
      };

      const excelBuffer: any = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });
      const blob: Blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      FileSaver.saveAs(blob, 'Module_Summary.xlsx');
    }


  }

  toggleAllSelectionForDept() {

    if (this.qmsDeptSelection) {
      this.qmsDeptVal.options.forEach((item: MatOption) => item.select());
    } else {
      this.qmsDeptVal.options.forEach((item: MatOption) => item.deselect())
      this.selectedQmsDept = [];
    }

  }


  onQmsDeptSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.qmsDeptSelection = this.dropDownForDepartmentCode.length == this.selectedQmsDept.length;
      })
    }
  }
}


